import { urls } from "../constants";
import { company } from "../company";
import { translations } from "./translations";
import { inToCm, lbToKg, ftToMeters, priceFtToMeters } from "../../js/utils"
import { dealersForm } from "../dealers_map"

const lang = "en";

const createFaqBlock = (title, description) => {
    return `<div class="faq-block underline">
        <div class="faq-title" aria-expanded="false">${title}<i class="fa fa-plus faq-icon"></i></div>
        <div class="faq-description hide_block">${description}</div>
    </div>`
}

function htmlToElement(html) {
  const template = document.createElement('template');
  template.innerHTML = html.trim(); // never parse leading/trailing whitespace
  return template.content.firstChild; 
}

function priceForm() {
	const container = document.createElement('div');
	container.className = 'row g-4';

	fetch('/get-pricelist')
		.then(response => {
			if (!response.ok) {
				throw new Error(`HTTP ${response.status}`);
			}
			return response.json();
		})
		.then(priceList => {
			console.log(priceList);
			const cards = priceList.map(item => `
				<div class="col-sm-6 col-md-4 col-lg-3">
				<div class="card h-100 shadow-sm">
					<div class="card-body d-flex flex-column">
					<h5 class="card-title">${item.display_name}</h5>
					<h6 class="card-subtitle mb-2 text-muted">${item.name}</h6>
					<p class="card-text mt-auto">
						<span class="fw-bold">$${item.list_price.toFixed(2)}</span>
					</p>
					<p class="card-text">
						<small class="text-secondary">
						${item.variant_names.join(', ')}
						</small>
					</p>
					</div>
				</div>
				</div>
			`).join('');

			container.appendChild(htmlToElement(cards));
		})
		.catch(err => {
			console.error('Failed to load prices:', err);
			container.innerHTML = `
				<div class="col-12">
				<div class="alert alert-danger">
					Error loading price list.
				</div>
				</div>
			`;
		});

		console.log(container);

	return container;
}

const faqContent = [
  {
    en: {
      title: "How does concrete not leak out the bottom?",
      body: `<div>
                <p>Fast-Tube prevents concrete from spilling out of the bottom due to "hoop tension".</p>
                <p>When concrete is placed inside Fast-Tube, the concrete pressure forces the horizontal weave in the fabric to run completely straight.</p>
                <p>This pressure makes Fast-Tube act just like a cardbord tube, sealing the fabric tight against the footing/pad it is sitting on.  You may find some concrete spill/wrinkling occur in the few seconds it takes for hoop tension to be created. </p>
            </div>`,
    },
    es: {
      title: "¿Cómo no verter el cemento?",
      body: `<div>
                <p>Fast-Tube evita que el concreto se derrame por la parte inferior debido a la "tensión del aro".</p>
                <p>Cuando se coloca el concreto dentro de Fast-Tube, la presión del concreto hace que el tejido horizontal en la tela se estire completamente.</p>
                <p>Esta presión hace que Fast-Tube actúe de manera similar a un tubo de cartón, sellando la tela firmemente contra la base o zapata sobre la que está apoyado. Es posible que se produzca algo de derrame de concreto o arrugas en los pocos segundos que tarda en generarse la tensión del aro.</p>
            </div>`,
    },
    fr: {
      title: "Comment le béton ne s'écoule-t-il pas par le fond ?",
      body: `<div>
                <p>Fast-Tube empêche le béton de s'écouler par le fond grâce à la "tension des arceaux".</p>
                <p>Lorsque le béton est placé à l'intérieur du Fast-Tube, la pression du béton force le tissage horizontal du tissu à être complètement droit.</p>
                <p>Cette pression permet à Fast-Tube d'agir comme un tube en carton, en scellant le tissu contre la semelle ou le socle sur lequel il repose. Il se peut qu'il y ait des déversements de béton ou des plis pendant les quelques secondes nécessaires à la création de la tension du cerceau.</p>
            </div>`,
    },
  },
  {
    en: {
      title: "How is the bottom fastened?",
      body: `<div>
                <p>The bottom of Fast-Tube is not fastened to the concrete pad, the vertical 2x4's supporting Fast-Tube are mechanically attached to the pad.</p>
            </div>`,
    },
    es: {
      title: "¿Cómo se fija el fondo?",
      body: `<div>
                <p>El fondo de Fast-Tube no está fijado a la losa de concreto; los 2x4 verticales que soportan Fast-Tube están fijados mecánicamente a la losa.</p>
            </div>`,
    },
    fr: {
      title: "Comment le fond est-il fixé ?",
      body: `<div>
                <p>Le fond du Fast-Tube n'est pas fixé à la dalle de béton, les 2x4 verticaux supportant le Fast-Tube sont fixés mécaniquement à la dalle.</p>
            </div>`,
    },
  },
  {
    en: {
      title: "How does it remain straight and plumb?",
      body: `<div>
                <p>The vertical 2x4's the Fast-Tube is attached to keep the column straight and allow you to plumb easily.</p>
            </div>`,
    },
    es: {
      title: "¿Cómo se mantiene recto y vertical?",
      body: `<div>
                <p>Los 2x4 verticales a los que está sujeto el Fast-Tube mantienen la columna recta y le permiten nivelarla con facilidad.</p>
            </div>`,
    },
    fr: {
      title: "Comment le Fast-Tube reste-t-il droit et d'aplomb ?",
      body: `<div>
                <p>Les 2x4 verticaux auxquels le Fast-Tube est attaché maintiennent la colonne droite et vous permettent de l'aplomb facilement.</p>
            </div>`,
    },
  },
  {
    en: {
      title: "How do I install rebar?",
      body: `<div>
                <p>Rebar can be installed either prior to or after installation of Fast-Tube.</p>
                <p>If only one or two lengths of rebar are required, it would be easiest to install these after the Fast-Tube is set in position. Carefully drop the rebar down the length of Fast-Tube, and tie to the dowels coming out of the pad. If necessary, you can stop the concrete pour 80% of the way up, and readjust the rebar to ensure they are in the correct position. Then continue your concrete pour. </p>
                <p>If a rebar cage is required, set up cage on top of pad and tie as required. Install one vertical 2x4 in the correct position and plumb in two directions.</p>
                <p>To protect the Fast-Tube from the rebar, cover the cage with a rag (or sweater off your back) and slide Fast-Tube over the rebar cage. Then staple Fast-Tube to the vertical 2x4, and sandwich with another.</p>
            </div>`,
    },
    es: {
      title: "¿Cómo instalo las varillas de refuerzo?",
      body: `<div>
            <p>Las varillas de refuerzo se pueden instalar antes o después de colocar el Fast-Tube.</p>
            <p>Si solo se requieren una o dos varillas de refuerzo, lo más fácil es instalarlas después de que el Fast-Tube esté en posición. Coloque cuidadosamente las varillas de refuerzo a lo largo del Fast-Tube y sujételas a los pasadores que sobresalen de la losa. Si es necesario, puede detener el vertido del concreto al 80% de su altura y reajustar las varillas para asegurarse de que estén en la posición correcta. Luego, continúe con el vertido del concreto.</p>
            <p>Si se requiere una jaula de varilla de refuerzo, coloque la jaula sobre la losa y átele según sea necesario. Instale un 2x4 vertical en la posición correcta y nivele en dos direcciones.</p>
            <p>Para proteger el Fast-Tube de las varillas de refuerzo, cubra la jaula con un trapo (o un suéter de su espalda) y deslice el Fast-Tube sobre la jaula de varillas. Luego, engrampe el Fast-Tube al 2x4 vertical y fíjelo con otro.</p>
        </div>`,
    },
    fr: {
      title: "Comment installer les barres d'armature ?",
      body: `<div>
            <p>Les barres d'armature peuvent être installées avant ou après l'installation du Fast-Tube.</p>
            <p>Si seulement une ou deux longueurs de barres d'armature sont nécessaires, il est plus facile de les installer après que le Fast-Tube ait été mis en place. Déposez soigneusement les barres d'armature le long du Fast-Tube et attachez-les aux goujons qui sortent du tampon. Si nécessaire, vous pouvez arrêter la coulée de béton à 80 % de sa hauteur et réajuster les barres d'armature pour vous assurer qu'elles sont dans la bonne position. Poursuivez ensuite la coulée de béton.</p>
            <p>Si une cage à barres d'armature est nécessaire, installez la cage sur le dessus de la dalle et fixez-la comme il se doit. Installez un 2x4 vertical dans la bonne position et d'aplomb dans deux directions.</p>
            <p>Pour protéger le Fast-Tube des barres d'armature, recouvrez la cage d'un chiffon (ou d'un pull sur votre dos) et faites glisser le Fast-Tube sur la cage d'armature. Ensuite, agrafez le Fast-Tube au 2x4 vertical, et sandwichez-le avec un autre.</p>
        </div>`,
    },
  },
  {
    en: {
      title: "How do I strip Fast-Tube?",
      body: `<div>
                <p>Remove 2x4's and simply pull on the alignment tab. Fast-Tube can then be recycled with other plastic materials onsite.</p>
            </div>`,
    },
    es: {
      title: "¿Cómo retiro el Fast-Tube?",
      body: `<div>
                <p>Retire los 2x4 y simplemente tire de la lengüeta de alineación. Luego, el Fast-Tube puede ser reciclado junto con otros materiales plásticos en el sitio.</p>
            </div>`,
    },
    fr: {
      title: "Comment démonter le Fast-Tube ?",
      body: `<div>
                <p>Retirez les 2x4 et tirez simplement sur la languette d'alignement. Fast-Tube peut ensuite être recyclé avec d'autres matériaux plastiques sur le site.</p>
            </div>`,
    },
  },
  {
    en: {
      title: "What sizes are available?",
      body: `<div>
                <p>8-18" diameter in 2" increments / 200-400mm in 50mm increments.</p>
            </div>`,
    },
    es: {
      title: "¿Qué tamaños están disponibles?",
      body: `<div>
                <p>Diámetro de 8 a 18 pulgadas en incrementos de 2 pulgadas / de 200 a 400 mm en incrementos de 50 mm</p>
            </div>`,
    },
    fr: {
      title: "Quelles sont les dimensions disponibles ?",
      body: `<div>
                <p>8-18" de diamètre par incréments de 2" / 200-400mm par incréments de 50mm.</p>
            </div>`,
    },
  },
  {
    en: {
      title: "Can I vibrate?",
      body: `<div>
                <p>Yes, we recommend vibrating with a pencil vibrator. Alternatively, you can externally vibrate with your hands as the column is filling. Ensure that you are lifting the vibrating head at the same rate of concrete placement.</p>
            </div>`,
    },
    es: {
      title: "¿Puedo vibrar?",
      body: `<div>
                <p>Sí, recomendamos vibrar con un vibrador de lápiz. Alternativamente, puede vibrar externamente con las manos mientras la columna se va llenando. Asegúrese de levantar la cabeza del vibrador a la misma velocidad que el vertido del concreto.</p>
            </div>`,
    },
    fr: {
      title: "Puis-je vibrer ?",
      body: `<div>
                <p>Oui, nous recommandons d'utiliser un vibrateur à crayon. Vous pouvez également vibrer de l'extérieur avec vos mains pendant que la colonne se remplit. Veillez à soulever la tête vibrante au même rythme que la mise en place du béton.</p>
            </div>`,
    },
  },
  {
    en: {
      title: "What is the finish like?",
      body: `<div>
                <p>Fast-Tube will produce a spiral free finish unlike cardboard tubes. Depending on placement, you may see a light grid pattern from the weave. The fast-tube can be stripped easily any time (from hours to years) after concrete placement, unlike a cardboard tube, which needs to be stripped immediately. Because you are working with a soft form, slight wrinkling and stretching can occur depending on installation.</p>
            </div>`,
    },
    es: {
      title: "¿Cómo es el acabado?",
      body: `<div>
                <p>Fast-Tube produce un acabado libre de espirales, a diferencia de los tubos de cartón. Dependiendo de la colocación, es posible que vea un patrón de cuadrícula ligero debido al tejido. El Fast-Tube puede retirarse fácilmente en cualquier momento (desde horas hasta años) después de colocar el concreto, a diferencia del tubo de cartón, que debe retirarse de inmediato. Debido a que se trabaja con un molde flexible, pueden ocurrir ligeras arrugas y estiramientos dependiendo de la instalación.</p>
            </div>`,
    },
    fr: {
      title: "Quelle est la finition ?",
      body: `<div>
                <p>Fast-Tube produit une finition sans spirale, contrairement aux tubes en carton. En fonction de la mise en place, il est possible que le tissage produise un léger quadrillage. Le Fast-Tube peut être décapé facilement à tout moment (de quelques heures à plusieurs années) après la mise en place du béton, contrairement au tube en carton qui doit être décapé immédiatement. Comme vous travaillez avec une forme souple, de légers plis et étirements peuvent se produire en fonction de l'installation.</p>
            </div>`,
    },
  },
  {
    en: {
      title: "How long can I leave it set up before I pour?",
      body: `<div>
                <p>Fast-Tube will never fail due to moisture. UV damage can occur if it is exposed to constants sunlight for more than 3 months. </p>
            </div>`,
    },
    es: {
      title:
        "¿Cuánto tiempo puedo dejarlo instalado antes de verter el concreto?",
      body: `<div>
                <p>Fast-Tube nunca fallará debido a la humedad. Sin embargo, puede sufrir daño por radiación ultravioleta (UV) si se expone a la luz solar constante por más de 3 meses.</p>
            </div>`,
    },
    fr: {
      title:
        "Combien de temps puis-je le laisser reposer avant de couler le béton ?",
      body: `<div>
                <p>Fast-Tube ne sera jamais endommagé par l'humidité. Des dommages dus aux UV peuvent se produire s'il est exposé à la lumière constante du soleil pendant plus de 3 mois.</p>
            </div>`,
    },
  },
  {
    en: {
      title: "How does it make a perfect circle?",
      body: `<div>
                <p>As long as you have earth's gravity, Fast-Tube has to form a circle. Concrete pressure equally fights against the weave in the fabric to produce a round column.</p>
            </div>`,
    },
    es: {
      title: "¿Cómo forma un círculo perfecto?",
      body: `<div>
                <p>Mientras tengas la gravedad de la Tierra, el Fast-Tube formará un círculo. La presión del concreto actúa de manera uniforme contra el tejido, lo que produce una columna redonda.</p>
            </div>`,
    },
    fr: {
      title: "Comment le tube Fast-Tube peut-il former un cercle parfait ?",
      body: `<div>
                <p>Tant qu'il y a la gravité terrestre, Fast-Tube doit former un cercle. La pression du béton lutte également contre la trame du tissu pour produire une colonne ronde.</p>
            </div>`,
    },
  },
  {
    en: {
      title: "Why do I need this and not just use poly?",
      body: `<div>
                <p>Fast-Tube is made of a strong woven Polyethylene. Poly would stretch and fail from concrete pressure.</p>
            </div>`,
    },
    es: {
      title: "¿Por qué necesito esto y no solo usar polietileno?",
      body: `<div>
                <p>Fast-Tube está hecho de un polietileno tejido resistente. El polietileno solo se estiraría y fallaría debido a la presión del concreto.</p>
            </div>`,
    },
    fr: {
      title:
        "Pourquoi ai-je besoin de cela et pas seulement d'utiliser du polyéthylène ?",
      body: `<div>
                <p>Fast-Tube est fabriqué à partir d'un polyéthylène tissé très résistant. Le polyéthylène s'étirerait et céderait sous la pression du béton.</p>
            </div>`,
    },
  },
  {
    en: {
      title: "How do I plumb it?",
      body: `<div>
                <p>Fast-Tube is easy to plumb as you have vertical 2x4's to adjust the column in both directions. You no longer have to make a lumber collar at the top of your cardboard tube to keep it plumb.</p>
            </div>`,
    },
    es: {
      title: "¿Cómo lo nivelamos?",
      body: `<div>
                <p>Fast-Tube es fácil de nivelar porque tiene 2x4 verticales que permiten ajustar la columna en ambas direcciones. Ya no es necesario hacer un collar de madera en la parte superior de su tubo de cartón para mantenerlo vertical.</p>
            </div>`,
    },
    fr: {
      title: "Comment l'installer ?",
      body: `<div>
                <p>Fast-Tube est facile à mettre d'aplomb car vous disposez de 2x4 verticaux pour ajuster la colonne dans les deux sens. Vous n'avez plus besoin de faire un collier de bois au sommet de votre tube en carton pour le maintenir d'aplomb.</p>
            </div>`,
    },
  },
  {
    en: {
      title: "Why is this better than cardboard tube?",
      body: `<div>
                <p>1/3rd the cost, 1/100th the space, faster to setup, waterproof, strips in seconds, no spiral finish, easy to recycle.</p>
            </div>`,
    },
    es: {
      title: "¿Por qué esto es mejor que el tubo de cartón?",
      body: `<div>
                <p>1/3 del costo, 1/100 del espacio, más rápido de instalar, impermeable, se retira en segundos, sin acabado en espiral, fácil de reciclar.</p>
            </div>`,
    },
    fr: {
      title: "Pourquoi ce système est-il meilleur que le tube en carton ?",
      body: `<div>
                <p>1/3 du coût, 1/100ème de l'espace, plus rapide à installer, imperméable, bandes en quelques secondes, pas de finition en spirale, facile à recycler.</p>
            </div>`,
    },
  },
  {
    en: {
      title: "How does it stay centered around rebar?",
      body: `<div>
                <p>The same as a cardboard tube. As long as your rebar, and your Fast-Tube are in the correct position prior to pouring, your rebar will be centered. There are no issues using rebar wheels with Fast-Tube to ensure your reinforcement in the correct position.</p>
            </div>`,
    },
    es: {
      title:
        "¿Cómo se mantiene centrado alrededor de las varillas de refuerzo?",
      body: `<div>
                <p>De la misma manera que con el tubo de cartón. Mientras las varillas de refuerzo y el Fast-Tube estén en la posición correcta antes del vertido, las varillas de refuerzo estarán centradas. No hay problemas al usar ruedas para varilla con Fast-Tube para asegurar que el refuerzo esté en la posición correcta.</p>
            </div>`,
    },
    fr: {
      title: "Comment reste-t-il centré autour de la barre d'armature ?",
      body: `<div>
                <p>De la même manière que pour le tube en carton. Tant que votre armature et votre Fast-Tube sont dans la bonne position avant le coulage, votre armature sera centrée. Il n'y a aucun problème à utiliser des roues pour barres d'armature avec Fast-Tube pour s'assurer que l'armature est dans la bonne position.</p>
            </div>`,
    },
  },
  {
    en: {
      title: "Can Fast-Tube be used below grade?",
      body: `<div>
                <p>Yes, but you cannot backfill until after concrete is poured. Attach Fast-Tube to a single piece of 2x4 that has a stake profile at one end. Drive this into the ground to hold in position, and plum off the top of the 2x4. When pouring concrete, begin slowly to allow the base of the Fast-Tube to lock off against the soil.</p>
            </div>`,
    },
    es: {
      title: "¿Se puede usar Fast-Tube debajo del nivel del suelo?",
      body: `<div>
                <p>Sí, pero no se puede rellenar hasta después de verter el hormigón. Fije Fast-Tube a una sola pieza de 2x4 que tenga un perfil de estaca en un extremo. Clávelo en el suelo para mantenerlo en posición y desprenda la parte superior del 2x4. Al verter el hormigón, comience lentamente para permitir que la base del tubo Fast-Tube se bloquee contra el suelo.</p>
            </div>`,
    },
    fr: {
      title: "Fast-Tube peut-il être utilisé sous le niveau du sol ?",
      body: `<div>
                <p>Sí, pero no puedes rellenar hasta después de verter el concreto. Sujeta el Fast-Tube a una sola pieza de 2x4 que tenga un perfil de estaca en un extremo. Clávate esto en el suelo para mantenerlo en posición y nivélalo desde la parte superior del 2x4. Al verter el concreto, comienza lentamente para permitir que la base del Fast-Tube se bloquee contra el suelo.</p>
            </div>`,
    },
  },
];

const mpssCalcForm = () => {
	return `<form id="foldDistanceForm">
				<div class="calc_ff_wrapper">
					<div class="calc-form-wrapper">
						<div class="calc-form-first-row">
							<div class="me-5"><i class="fa fa-calculator calc-icon" aria-hidden="true"></i></div>
							<div class="calc_ft_block">
								<div class="calc_ft_line row">
									<label for="footingWidth" class="calc_ft_label">Footing width (in)</label>
									<input type="number" class="calc-ft-input input-width me-2" id="footingWidth" name="footingWidth">
								</div>
								<div class="calc_ft_line row">
									<label for="footingHeight" class="calc_ft_label">Footing height (in)</label>
									<input type="number" class="calc-ft-input input-width me-2" id="footingHeight" name="footingHeight">
								</div>
								<div class="calc_ft_line row">
									<label for="wallThickness" class="calc_ft_label">Concrete wall (in)</label>
									<input type="number" class="calc-ft-input input-width me-2" id="wallThickness" name="wallThickness">
								</div>
								<div class="calc_ft_line row">
									<label for="epsThickness" class="calc_ft_label">Foam thickness (in)</label>
									<input type="number" class="calc-ft-input input-width me-2" id="epsThickness" name="epsThickness">
								</div>
								<div class="calc_ft_line row">
									<label for="battenWidth" class="calc_ft_label">Batten width (in)</label>
									<input type="number" class="calc-ft-input input-width me-2" id="battenWidth" name="battenWidth">
								</div>
								<div class="calc_ft_line row">
									<label for="battenThickness" class="calc_ft_label">Batten thickness (in)</label>
									<input type="number" class="calc-ft-input input-width me-2" id="battenThickness" name="battenThickness">
								</div>
							</div>
						</div>	
						<div class="calc_ft_buttons">
							<button type="button" id="fieldDistance_button" class="ft-button">Calculate Fold Distance</button>
							<button type="reset" id="reset" class="ft-button">Reset</button>
						</div>
					</div>
					<div class="result-table-wrapper">
						<div>
							<div class="calc_ft_line row">
								<label for="foldDistanceResult" class="calc_ft_label">Fabric fold distance (in)</label>
								<input type="number" class="calc-ft-input input-width me-2 white" id="foldDistanceResult" name="foldDistanceResult" readonly disabled>
							</div>
							<div class="calc_ft_line row">
								<label for="fastfootSize" class="calc_ft_label">Fastfoot size</label>
								<input type="text" class="calc-ft-input input-width me-2 white" id="fastfootSize" name="fastfootSize" readonly disabled>
							</div>
						</div>
					</div>
				</div>
			</form>`
}

const constEffectiveFrom = (lang) => {
	return `<form id="calc_ft_form">
		<div class="calc_ft_wrapper">
			<div class="calc-form-wrapper">
			<div class="calc-input-wrapper">
				<div class="me-5"><i class="fa fa-calculator fa-3x calc-icon" aria-hidden="true"></i></div>
				<div class="calc_ft_block">
					<div class="calc_ft_line">
						<label for="columnHeight" class="calc_ft_label">${translations.columnHeight[lang]}</label>
						<input type="number" id="columnHeight" value=${ftToMeters(11)} min="0" class="calc-ft-input input-width">
					</div>
					<div class="calc_ft_line">
						<label for="diameter" class="calc_ft_label">${translations.diameter[lang]}</label>
						<select type="number" id="diameter" class="select-width calc-ft-input">
							<option value="8" data-value="8">${inToCm(8)}</option>
							<option value="10" data-value="10">${inToCm(10)}</option>
							<option value="12" data-value="12" selected="selected">${inToCm(12)}</option>
							<option value="14" data-value="14">${inToCm(14)}</option>
							<option value="16" data-value="16">${inToCm(16)}</option>
						</select>
					</div>
					<div class="calc_ft_line">
						<label for="labourCost" class="calc_ft_label">${translations.labourCostPerHour[lang]}</label>
						<input type="number" id="labourCost" value="25" min="0" class="calc-ft-input input-width">
					</div>
					<div class="calc_ft_line">
						<label for="columns" class="calc_ft_label">${translations.numberOfColumns[lang]}</label>
						<input type="number" id="columns" value="10" min="0" class="calc-ft-input input-width">
					</div>
					<div class="calc_ft_line">
						<label for="cardboardLenght" class="calc_ft_label">${translations.cardboardLength[lang]}</label>
						<select type="number" id="cardboardLenght" class="select-width calc-ft-input">
							<option value="4">${ftToMeters(4)}</option>
							<option value="8">${ftToMeters(8)}</option>
							<option value="12" selected="selected">${ftToMeters(12)}</option>
						</select>
					</div>
					<div class="calc_ft_line">
						<label for="cardboardPrice" class="calc_ft_label">${translations.cardboardPrice[lang]}</label>
						<input type="number" id="cardboardPrice" value="48" min="0" class="calc-ft-input input-width">
					</div>
					<div class="calc_ft_line">
						<label for="shippingCost" class="calc_ft_label">${translations.shippingCost[lang]}</label>
						<input type="number" id="shippingCost" value=${priceFtToMeters(1.25)} min="0" class="calc-ft-input input-width">
					</div>
					<div class="calc_ft_line">
						<label for="sendEmailCheckbox" class="calc_ft_label">Email a copy</label>
						<input type="checkbox" id="sendEmailCheckbox" class="calc-ft-input input-width checkbox" checked>
					</div>
					<div id="liveAlertPlaceholder"></div>
				</div>
			</div>
			<div class="calc_ft_buttons">
				<input type="button" value='${translations.calculate[lang]}' id="estimate_ft" class="ft-button">
				<input type="reset" value='${translations.reset[lang]}' id="reset" class="ft-button">
				<input type="button" value="${translations.buyNow[lang]}" id="buyNowCalc" target="_blank" onclick="return gtag_report_conversion('https://fast-tube.com');" class="ft-button"> 
			</div>
			</div>
			<div class="result-table-wrapper">
				<div class="res_st_block">
					<table>
						<thead>
							<tr><th class="result_ft_brand">Cardboard tube</th><th>${translations.cost[lang]}</th><th>${translations.qty[lang]}</th><th>$</th></tr>
						</thead>
						<tbody id="resultBody">
							<tr><td class="result_ft_label">${translations.columnForm[lang]}</td><td id="stColumnCost"></td><td id="stColumnQty"></td><td id="stColumnTotal"></td></tr>
							<tr><td class="result_ft_label">${translations.shipping[lang]}</td><td id="stShippingCost"></td><td id="stShippingQty"></td><td id="stShippingTotal"></td></tr>
							<tr><td class="result_ft_label">${translations.strippingLabor[lang]}</td><td id="stLaborCost"></td><td id="stLaborQty"></td><td id="stLaborTotal"></td></tr>
							<tr><td class="result_ft_label">${translations.total[lang].toUpperCase()}</td><td colspan="3" id="stTotal"></td></tr>                      
						</tbody>
					</table>
				</div>
				<div class="res_ft_block">
				<table>
					<thead>
					<tr><th class="result_ft_brand">FAST-TUBE</th><th>${translations.cost[lang]}</th><th>${translations.qty[lang]}</th><th>$</th></tr>
					</thead>
					<tbody id="resultBody">
						<tr><td class="result_ft_label">${translations.columnForm[lang]}</td><td id="ftColumnCost"></td><td id="ftColumnQty"></td><td id="ftColumnTotal"></td></tr>
						<tr><td class="result_ft_label">${translations.shipping[lang]}</td><td id="fttShippingCost"></td><td id="ftShippingQty"></td><td id="ftShippingTotal"></td></tr>
						<tr><td class="result_ft_label">${translations.strippingLabor[lang]}</td><td id="ftLaborCost"></td><td id="ftLaborQty"></td><td id="ftLaborTotal"></td></tr>
						<tr><td class="result_ft_label">${translations.total[lang].toUpperCase()}</td><td colspan="3" id="ftTotal"></td></tr>                      
					</tbody>
				</table>
			</div>
			<div class="modal estimator_modal" tabindex="-1" role="dialog">
			<div class="modal-dialog" role="document">
			  <div class="modal-content">
				<div class="modal-header">
				  <h5 class="modal-title">Would you like to get a copy on email?</h5>
				  <button type="button" class="close-estimator-modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				  </button>
				</div>
				<div class="modal-body">
					<input type="text" id="estimatorUserName" class="form-control mb-1" placeholder="Your name">
					<input type="email" id="estimatorUserEmail" class="form-control" placeholder="Email address">
				</div>
				<div class="modal-footer">
				  <button type="button" id="calculateAndSend" class="ft-button">Calculate and send</button>
				  <button type="button" id="calculateOnly" class="ft-button">Calculate only</button>
				</div>
			  </div>
			</div>
		  </div>
		</div>
	</div>
</form>`
}

const ffCostEstimator = (lang, type) => {
	return `
		<form id="calc_ff_form" data-type=${type}>
			<div class="calc_ff_wrapper">
				<div class="calc-form-wrapper">
					<div class="calc-form-first-row">
						<div class="me-5"><i class="fa fa-calculator calc-icon" aria-hidden="true"></i></div>
						<div class="calc_ft_block">
							<div class="ff-inputs-wrapper">
								<div class="container text-center">
									<div id="widthInputRow" class="calc_ft_line row">
										<label class="calc_ft_label" for="width" id="widthLabel">${type === "residential" ? translations.width[lang] : translations.padWidth[lang]}</label>
										<input type="number" name="width" id="width-1" class="calc-ft-input input-width me-2">
									</div>
									<div id="heightInputRow" class="calc_ft_line row">
										<label class="calc_ft_label" for="height">${type === "residential" ? translations.height[lang] : translations.padHeight[lang]}</label>
										<input type="number" name="height" id="height-1" class="calc-ft-input input-width me-2">
									</div>
									<div id="lengthInputRow" class="calc_ft_line row">
										<label class="calc_ft_label" for="length">${type === "residential" ? translations.perimeter[lang] : translations.padLength[lang]}</label>
										<input type="number" name="length" id="length-1" class="calc-ft-input input-width me-2">
									</div>
									<div id="qtyInputRow" class="calc_ft_line row">
										<label class="calc_ft_label" for="quantity">${type === "residential" ? translations.corners[lang] : translations.numberPads[lang]}</label>
										<input type="number" name="quantity" id="qty-1" class="calc-ft-input input-width me-2">
									</div>
									<div class="calc_ft_line row">
										<label class="calc_ft_label" for="lumberCost">
											<div id="lumber-mbf" class="result_ft_label question-mark">
												<span>${translations.lumberCost[lang]}</span>
												<i class="fa fa-question" aria-hidden="true"></i>
												<div class="modal hint-lumber-mbf" tabindex="-1">
													<div class="modal-dialog">
														<div class="modal-content">
															<div class="modal-body">
																<p>${translations.lumberMbfHint[lang]}</p>
															</div>
														</div>
													</div>
												</div>
											</div>
										</label>
										<input type="number" name="lumberCost" id="lumberCost" class="calc-ft-input input-width me-2">
									</div>
									${type === "commercial" 
										?  `<div class="calc_ft_line row plywood">
												<label class="calc_ft_label question-mark" for="plywood" id="plywood">
													<span>${translations.plywoodCost[lang]}</span>
													<i class="fa fa-question" aria-hidden="true"></i>
													<div class="modal hint-plywood" tabindex="-1">
														<div class="modal-dialog">
															<div class="modal-content">
																<div class="modal-body">
																	<p>${translations.plywoodHint[lang]}</p>
																</div>
															</div>
														</div>
													</div>
												</label>
											<input type="number" name="plywoodCost" id="plywoodCost" class="calc-ft-input input-width me-2" value="1.5">
										</div>`
										: ''
									}
									<div class="calc_ft_line row">
										<label class="calc_ft_label" for="labourCost">${translations.laborCost[lang]}</label>
										<input type="number" name="labourCost" id="labourCost" class="calc-ft-input input-width me-2" value="30">
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="calc_ft_buttons">
						<input type="button" value='${translations.addFooting[lang]}' id="estimate_add" class="ft-button">
						<input type="button" value='${translations.calculate[lang]}' id="estimate-cost-ff" class="ft-button">
						<input type="reset" value='${translations.reset[lang]}' id="reset" class="ft-button">
					</div>
				</div>
				<div class="result-table-wrapper">
					<div class="res_st_block mb-4">
						<table>
							<thead>
								<tr>
									<th class="result_ft_label">${translations.cost[lang]}</th>
									<th class="result_ft_brand">Fastfoot</th>
									<th class="result_ft_brand">${translations.plywood[lang]}</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td id="material" class="result_ft_label question-mark">
										<span>${translations.material[lang]}&nbsp;</span>
										<i class="fa fa-question" aria-hidden="true"></i>
										<div class="modal hint-material" tabindex="-1">
											<div class="modal-dialog">
												<div class="modal-content">
													<div class="modal-body">
														<p>${translations.materialHint[lang]}</p>
													</div>
												</div>
											</div>
										</div>   
									</td>
									<td id="totalMaterialCostFF"></td>
									<td id="totalMaterialCostPlywood"></td>
								</tr>
								<tr>
									<td id="lumber" class="result_ft_label question-mark">
										<span>${translations.lumber[lang]}&nbsp;</span>
										<i class="fa fa-question" aria-hidden="true"></i>
										<div class="modal hint-lumber" tabindex="-1">
											<div class="modal-dialog">
												<div class="modal-content">
													<div class="modal-body">
														<p>${translations.lumberHint[lang]}</p>
													</div>
												</div>
											</div>
										</div>
									</td>
									<td id="totalLumberCostFF"></td>
									<td id="totalLumberCostPlywood"></td>
								</tr>
								<tr>
									<td class="result_ft_label">${translations.labour[lang]}</td>
									<td id="totalLabourCostFF"></td>
									<td id="totalLabourCostPlywood"></td>
								</tr>
								<tr>
									<td class="result_ft_label">${translations.total[lang]}</td>
									<td id="totalCostFF"></td>
									<td id="totalCostPlywood"></td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="res_st_block">
						<table>
							<thead>
								<tr id="headerResultRow">
									<th class="result_ft_label">${translations.results[lang]}</th>
									<th class="result_ft_label">#1</th>
								</tr>
							</thead>
							<tbody>
								<tr id="methodResultRow">
									<td id="method" class="result_ft_label question-mark">
										<span>${translations.method[lang]}</span>
										<i class="fa fa-question" aria-hidden="true"></i>
										<div class="modal hint-method" tabindex="-1">
											<div class="modal-dialog">
												<div class="modal-content">
													<div class="modal-body">
														${translations.methodHint[lang]}
													</div>
												</div>
											</div>
										</div>
									</td>
									<td id="method-1"></td>
								</tr>
								<tr id="sizeResultRow">
									<td id="size" class="result_ft_label question-mark">
										<span>${translations.size[lang]}</span>
										<i class="fa fa-question" aria-hidden="true"></i>
										<div class="modal hint-size" tabindex="-1">
											<div class="modal-dialog">
												<div class="modal-content">
													<div class="modal-body">
														<p>${translations.sizeHint[lang]}</p>
													</div>
												</div>
											</div>
										</div>
									</td>
									<td id="size-1"></td>
								</tr>
								<tr id="qtyResultRow">
									<td class="result_ft_label">${translations.corners[lang]}</td>
									<td id="quantity-1"></td>
								</tr>
								<tr id="rollResultRow">
									<td class="result_ft_label">${translations.rolls[lang]}</td>
									<td id="roll-1"></td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>   
			</div>
		</form>
	`
}

const residentialInstallPage = (lang) => {
	return `
		<div id="residential" class="article-content-wrapper">
			<div class="article-content-wrapper mt-5">
				<div class="article-text-block text-50">
					<h3 class="article_title">1. ${translations.install_res_step_1_title[lang]}</h3>
					<div class="install-text-block">${translations.install_res_step_1_text[lang]}</div>
				</div>
				<div class="article-media-block media-50">
					<div class="install-svg ff-install-1"></div>
				</div>
			</div>
			<div class="article-content-wrapper mt-5">
				<div class="article-text-block text-50">
					<h3 class="article_title">2. ${translations.install_res_step_2_title[lang]}</h3>
					<div class="install-text-block">
						<ul>
							${translations.install_res_step_2_text[lang]}
						</ul>
					</div>
				</div>
				<div class="article-media-block media-50">
					<div class="install-svg ff-install-2"></div>
				</div>
			</div>
			<div class="article-content-wrapper mt-5">
				<div class="article-text-block text-50">
					<h3 class="article_title">3. ${translations.install_res_step_3_title[lang]}</h3>
					<div class="install-text-block">
						${translations.install_res_step_3_text[lang]}
					</div>
				</div>
				<div class="article-media-block media-50">
					<div class="install-svg ff-install-3"></div>
				</div>
			</div>
			<div class="article-content-wrapper mt-5">
				<div class="article-text-block text-50">
					<h3 class="article_title">4. ${translations.install_res_step_4_title[lang]}</h3>
					<div class="install-text-block">
						${translations.install_res_step_4_text[lang]}
					</div>
				</div>
				<div class="article-media-block media-50">
					<div class="install-svg ff-install-4"></div>
				</div>
			</div>
			<div class="article-content-wrapper mt-5">
				<div class="article-text-block text-50">
					<h3 class="article_title">${translations.install_res_t_junctions_title[lang]}</h3>
					<div class="install-text-block">
						${translations.install_res_t_junctions_text[lang]}
					</div>
				</div>
				<div class="article-media-block media-50">
					<div class="install-svg t-junction"></div>
				</div>
			</div>
			<div class="article-content-wrapper mt-5">
				<h3 class="article_title">${translations.install_res_steps_title[lang]}</h3>
				<ul class="install-text-block">
					<li>
						<div class="article-content-wrapper">
							<div class="article-text-block text-50">${translations.install_res_steps_1_text[lang]}</div>
							<div class="article-media-block media-50">
								<div class="install-step-svg ff-step-1"></div>
							</div>
						</div>
					</li>
					<li>
						<div class="article-content-wrapper">
							<div class="article-text-block text-50">${translations.install_res_steps_2_text[lang]}</div>
							<div class="article-media-block media-50">
								<div class="install-step-svg ff-step-2"></div>
							</div>
						</div>
					</li>
					<li>
						<div class="article-content-wrapper">
							<div class="article-text-block text-50">${translations.install_res_steps_3_text[lang]}</div>
							<div class="article-media-block media-50">
								<div class="install-step-svg ff-step-3"></div>
							</div>
						</div>
					</li>
					<li>
						<div class="article-content-wrapper">
							<div class="article-text-block text-50">${translations.install_res_steps_4_text[lang]}</div>
							<div class="article-media-block media-50">
								<div class="install-step-svg ff-step-4"></div>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
	`
}

const commercialInstallPage = (lang) => {
	return `
		<div id="commercial" class="article-content-wrapper">
			<div class="article-content-wrapper mt-5">
				<div class="article-text-block text-50">
					<h3 class="article_title">1. ${translations.install_com_step_1_title[lang]}</h3>
					<div class="install-text-block">${translations.install_com_step_1_text[lang]}</div>
				</div>
				<div class="article-media-block media-50">
					<div class="install-svg ff-com-1"></div>
				</div>
			</div>
			<div class="article-content-wrapper mt-5">
				<div class="article-text-block text-50">
					<h3 class="article_title">2. ${translations.install_com_step_2_title[lang]}</h3>
					<div class="install-text-block">${translations.install_com_step_2_text[lang]}</div>
				</div>
				<div class="article-media-block media-50">
					<div class="install-svg ff-com-2"></div>
				</div>
			</div>
			<div class="article-content-wrapper mt-5">
				<div class="article-text-block text-50">
					<h3 class="article_title">3. ${translations.install_com_step_3_title[lang]}</h3>
					<div class="install-text-block">${translations.install_com_step_3_text[lang]}</div>
				</div>
				<div class="article-media-block media-50">
					<div class="install-svg ff-com-3"></div>
				</div>
			</div>
		</div>
	`
}

const rollSize = (lang) => {
	return `
		<div class="rising-damp-block">
			<div class="container packaging">
				<div class="row row_underline align-items-center">
					<div class="col"></div>
					<div class="col text-center">FF50</div>
					<div class="col text-center">FF62</div>
					<div class="col text-center">FF74</div>
				</div>
				<div class="row row_underline align-items-center">
					<div class="col">${translations.typicalWidthDepth[lang]}</div>
					<div class="col text-center">${inToCm(18, true)} / ${inToCm(10, true)}</div>
					<div class="col text-center">${inToCm(24, true)} / ${inToCm(13, true)}</div>
					<div class="col text-center">${inToCm(36, true)} / ${inToCm(13, true)}</div>
				</div>
				<div class="row row_underline align-items-center">
					<div class="col">${translations.maxSlabDepth[lang]}</div>
					<div class="col text-center">${inToCm(25, true)}</div>
					<div class="col text-center">${inToCm(31, true)}</div>
					<div class="col text-center">${inToCm(37, true)}</div>
				</div>
				<div class="row row_underline align-items-center">
					<div class="col">${translations.rollSize[lang]}</div>
					<div class="col text-center">${inToCm(50, true)} x ${ftToMeters(100, true)}</div>
					<div class="col text-center">${inToCm(62, true)} x ${ftToMeters(100, true)}</div>
					<div class="col text-center">${inToCm(74, true)} x ${ftToMeters(100, true)}</div>
				</div>
				<div class="row row_underline align-items-center">
					<div class="col">${translations.weight[lang]}</div>
					<div class="col text-center">${lbToKg(11.2, true)}</div>
					<div class="col text-center">${lbToKg(13.9, true)}</div>
					<div class="col text-center">${lbToKg(16.6, true)}</div>
				</div>
				<div class="row row_underline align-items-center">
					<div class="col">${translations.qtyBox[lang]}</div>
					<div class="col text-center">4</div>
					<div class="col text-center">4</div>
					<div class="col text-center">4</div>
				</div>
				<div class="row row_underline align-items-center">
					<div class="col">${translations.boxSize[lang]}</div>
					<div class="col text-center">${inToCm(10, false)} x ${inToCm(10, false)} x ${inToCm(27, true)}</div>
					<div class="col text-center">${inToCm(10, false)} x ${inToCm(10, false)} x ${inToCm(33, true)}</div>
					<div class="col text-center">${inToCm(10, false)} x ${inToCm(10, false)} x ${inToCm(39, true)}</div>
				</div>
				<div class="row row_underline align-items-center">
					<div class="col">${translations.boxWeigth[lang]}</div>
					<div class="col text-center">${lbToKg(46, true)}</div>
					<div class="col text-center">${lbToKg(57, true)}</div>
					<div class="col text-center">${lbToKg(68, true)}</div>
				</div>
			</div>
		</div>
	`
}

const cornerSize = (lang) => {
	return `
		<div class="rising-damp-block">
			<p>${translations.roll_size_description[lang]}</p>
			<div class="container packaging">
				<div class="row row_underline align-items-center">
					<div class="col"></div>
					<div class="col text-center">FF50C</div>
					<div class="col text-center">FF62C</div>
					<div class="col text-center">FF74C</div>
				</div>
				<div class="row row_underline align-items-center">
					<div class="col">${translations.weight[lang]}</div>
					<div class="col text-center">${lbToKg(0.65, true, 1)}</div>
					<div class="col text-center">${lbToKg(0.75, true, 1)}</div>
					<div class="col text-center">${lbToKg(0.85, true, 1)}</div>
				</div>
				<div class="row row_underline align-items-center">
					<div class="col">${translations.qtyBox[lang]}</div>
					<div class="col text-center">20</div>
					<div class="col text-center">20</div>
					<div class="col text-center">20</div>
				</div>
				<div class="row row_underline align-items-center">
					<div class="col">${translations.boxSize[lang]}</div>
					<div class="col text-center">${inToCm(14, false)} x ${inToCm(14, false)} x ${inToCm(8, true)}</div>
					<div class="col text-center">${inToCm(18, false)} x ${inToCm(13, false)} x ${inToCm(8, true)}</div>
					<div class="col text-center">${inToCm(22, false)} x ${inToCm(15, false)} x ${inToCm(8, true)}</div>
				</div>
				<div class="row row_underline align-items-center">
					<div class="col">${translations.boxWeigth[lang]}</div>
					<div class="col text-center">${lbToKg(13, true)}</div>
					<div class="col text-center">${lbToKg(15, true)}</div>
					<div class="col text-center">${lbToKg(17, true)}</div>
				</div>
			</div>
		</div>
	`
}

const specLibs = (lang) => {
	return `
		<div class="specification-parent">
			<ul>
				<li class="mb-4"><p>${translations.technical[lang]}</p>
					<div class="specification-child">
						<ul>
							<li><a href="/docs/fastfoot-specifications.pdf" target="_blank">${translations.specifications[lang]}</a></li>
							<li><a href="/docs/fastfoot-engineering-letter.pdf" target="_blank">${translations.structuralEngineerLetter[lang]}</a></li>
							<li><a href="/docs/fastfoot-engineering-ns.pdf" target="_blank">${translations.structuralEngineerLetterNovaScotia[lang]}</a></li>
							<li><a href="/docs/fastfoot-engineering-ca.pdf" target="_blank">${translations.structuralEngineerLetterCalifornia[lang]}</a></li>
							<li><a href="/docs/electrical-engineering-letter-ufer-rod.pdf" target="_blank">${translations.electricalEngineerLetterUferRod[lang]}</a></li>
							<li><a href="/docs/cmhc-molds-in-finished-basements.pdf" target="_blank">${translations.CMHCReportOnMold[lang]}</a></li>
							<li><a href="/docs/fastfoot-installation.pdf" target="_blank">${translations.fastfootInstallationGuide[lang]}</a></li>
							<li><a href="/docs/fastfoot-msds.pdf" target="_blank">${translations.materialSafetyDataSheet[lang]}</a></li>
							<li><a href="/docs/fastfoot-angle-of-interface-friction.pdf" target="_blank">${translations.testReportOnAingle[lang]}</a></li>
							<li><a href="/docs/fastfoot-csi-specification.pdf" target="_blank">${translations.CSISpecifications[lang]}</a></li>
							<li><a href="/docs/fastfoot_footing_letter_peo_stp.pdf" target="_blank">${translations.engineerCertificateOntario[lang]}</a></li>
						</ul>
					</div>
				</li>
				<li><p>${translations.marketingMaterials[lang]}</p>
					<div class="specification-child">
						<ul>
							<li><a href="/images/fastfoot-display.webp" target="_blank">${translations.fastfootPointOfsaleDisplay[lang]}</a></li>
							<li><a href="/docs/fastfoot-brochure.pdf" target="_blank">${translations.fastfootBrochure[lang]}</a></li>
							<li><a href="/docs/fastfoot-dealer-binder.pdf" target="_blank">${translations.dealerBinder[lang]}</a></li>
						</ul>
					</div>
				</li>
			</ul>
		</div>
	`
}

const maxPourTable = (lang) => {
	return `<table class="ft_safety">
		<thead>
			<tr class="header">
				<td>${translations.diameter[lang]}</td>
				<td>${inToCm(8)}</td>
				<td>${inToCm(10)}</td>
				<td>${inToCm(12)}</td>
				<td>${inToCm(14)}</td>
				<td>${inToCm(16)}</td>
				<td>${inToCm(18)}</td>
			</tr>
		</thead>
		<tbody>
			<tr>
				<td>${translations.columnHeight[lang]}</td>
				<td class="green-cell">${ftToMeters(46)}</td>
				<td class="green-cell">${ftToMeters(36)}</td>
				<td class="green-cell">${ftToMeters(30)}</td>
				<td class="green-cell">${ftToMeters(26)}</td>
				<td class="green-cell">${ftToMeters(23)}</td>
				<td class="green-cell">${ftToMeters(20)}</td>
			</tr>
		</tbody>
	</table>`
}

const sizeTable = (lang) => {
	return `<table class="ft_dimensions">
	<thead>
	<tr>
		<th colspan="2">${translations.diameter[lang]}</td>
		<th>${translations.length[lang]}</td>
		<th>${translations.weight[lang]}</td>
		<th>${translations.qtyBox[lang]}</td>
		<th>${translations.boxSize[lang]}</td>
		<th>${translations.boxWeigth[lang]}</td>
	</tr>
	</thead> 
	<tbody>
		<tr>
			<td rowspan="2">FT8</td>
			<td rowspan="2">${inToCm(8)}</td>
			<td>${ftToMeters(100)}</td>
			<td>${lbToKg(11)}</td>
			<td>2</td>
			<td>${inToCm(11)}x${inToCm(21)}x${inToCm(13)}</td>
			<td>${lbToKg(24)}</td>
		</tr>
		<tr>
			<td>${ftToMeters(10)}</td>
			<td>${lbToKg(1.3)}</td>
			<td>20</td>
			<td>${inToCm(11)}x${inToCm(21)}x${inToCm(13)}</td>
			<td>${lbToKg(27)}</td>
		</tr>
		<tr>
			<td rowspan="2">FT10</td>
			<td rowspan="2">${inToCm(10)}</td>
			<td>${ftToMeters(100)}</td>
			<td>${lbToKg(13.3)}</td>
			<td>2</td>
			<td>${inToCm(11)}x${inToCm(21)}x${inToCm(16)}</td>
			<td>${lbToKg(28)}</td>
		</tr>
		<tr>
			<td>${ftToMeters(10)}</td>
			<td>${lbToKg(1.5)}</td>
			<td>20</td>
			<td>${inToCm(11)}x${inToCm(21)}x${inToCm(16)}</td>
			<td>${lbToKg(31)}</td>
		</tr>
		<tr>
			<td rowspan="2">FT12</td>
			<td rowspan="2">${inToCm(12)}</td>
			<td>${ftToMeters(100)}</td>
			<td>${lbToKg(15.5)}</td>
			<td>2</td>
			<td>${inToCm(11)}x${inToCm(21)}x${inToCm(20)}</td>
			<td>${lbToKg(33)}</td>
		</tr>
		<tr>
			<td>${ftToMeters(10)}</td>
			<td>${lbToKg(1.7)}</td>
			<td>20</td>
			<td>${inToCm(11)}x${inToCm(21)}x${inToCm(20)}</td>
			<td>${lbToKg(35)}</td>
		</tr>
		<tr>
			<td rowspan="2">FT14</td>
			<td rowspan="2">${inToCm(14)}</td>
			<td>${ftToMeters(100)}</td>
			<td>${lbToKg(19)}</td>
			<td>2</td>
			<td>${inToCm(11)}x${inToCm(21)}x${inToCm(23)}</td>
			<td>${lbToKg(38)}</td>
		</tr>
		<tr>
			<td>${ftToMeters(10)}</td>
			<td>${lbToKg(1.9)}</td>
			<td>20</td>
			<td>${inToCm(11)}x${inToCm(21)}x${inToCm(23)}</td>
			<td>${lbToKg(39)}</td>
		</tr>
		<tr>
			<td rowspan="2">FT16</td>
			<td rowspan="2">${inToCm(16)}</td>
			<td>${ftToMeters(100)}</td>
			<td>${lbToKg(21)}</td>
			<td>2</td>
			<td>${inToCm(11)}x${inToCm(21)}x${inToCm(26)}</td>
			<td>${lbToKg(42)}</td>
		</tr>
		<tr>
			<td>${ftToMeters(10)}</td>
			<td>${lbToKg(2.1)}</td>
			<td>20</td>
			<td>${inToCm(11)}x${inToCm(21)}x${inToCm(26)}</td>
			<td>${lbToKg(43)}</td>
		</tr>
		<tr>
			<td rowspan="2">FT18</td>
			<td rowspan="2">${inToCm(18)}</td>
			<td>${ftToMeters(100)}</td>
			<td>${lbToKg(23)}</td>
			<td>2</td>
			<td>${inToCm(11)}x${inToCm(21)}x${inToCm(30)}</td>
			<td>${lbToKg(46)}</td>
		</tr>
		<tr>
			<td>${ftToMeters(10)}</td>
			<td>${lbToKg(2.4)}</td>
			<td>20</td>
			<td>${inToCm(11)}x${inToCm(21)}x${inToCm(30)}</td>
			<td>${lbToKg(49)}</td>
		</tr>
		</tbody>
	</table>`
}

export default [
  {
    id: "fastFootForms",
    menuItem: {
      en: {
        title: "Fastfoot",
        menu: "Fastfoot",
        underTitle: "Footings",
        shortDescription: `
			<div>
				Fastfoot® <a class="product-link" href="/${lang}/${urls.fastFoot.residential}">Residential</a> and <a class="product-link" href="/${lang}/${urls.fastFoot.commercial}">Commercial</a> footing forms are made of high-density polyethylene fabric. Fastfoot<sup>®</sup> is a green replacement for lumber and plywood when forming concrete footings.</p>
			</div>`,
      },
    },
    image: "/images/ff_footing_forms.webp",
    isProduct: true,
    content: [
      {
        id: "residential",
        menuItem: {
          en: {
            title: "Residential",
            menu: "Residential",
          },
        },
        content: [
          {
            id: "overview",
            menuItem: {
              en: {
                title: "Fastfoot Residential Overview",
                menu: "Overview",
                url: urls.fastFoot.residential.overview,
                metaTitle: "Fastfoot Residential Overview - Cost-Effective Footing Solutions",
                metaDescription: "Discover Fastfoot® for residential concrete footings, offering a more affordable, durable, and environmentally friendly alternative to traditional lumber. Learn about its advantages, including preventing concrete damage and adapting to uneven ground.",
              },
            },
            category: "fastFootForms",
            images: [],
            videos: [],
            articles: [
              {
                title: "Less Expensive than lumber",
                body: `<p>Fastfoot is significantly less expensive than dimensional lumber to form concrete 
										footings. <a href="/${lang}/${urls.fastFoot.residential.estimator}" title="Fastfoot Cost Compare">See the cost comparison.</a></p>`,
                image: "",
              },
              {
                title: "Prevents Concrete Damage",
                body: `<p>Fastfoot<sup>®</sup> is a closed form. As seen from this photo there is no concrete damage to 
										screed boards and stakes. This means your 2x4s and stakes can be re-used indefinitely.</p>`,
                image: "/images/no-concrete-damage.webp",
              },
              {
                title: "Adapts to Uneven Ground, Rock",
                body: `<p>Special colored width lines allow Fastfoot<sup>®</sup> to be 'let out' or 'pulled in' to 
										accommodate uneven excavations. No need to scab lumber on the sides of your footings or 
										shovel the ground to achieve the footing depth. Fastfoot<sup>®</sup> is perfect over rock as shown in 
										this photo.</p>`,
                image: "/images/adapts-to-uneven-ground.webp",
              },
              {
                title: "Ideal for Stepped Footings",
                body: `<p>Fastfoot<sup>®</sup> quickly adapts to the uneven contours of your bank. No need to waste plywood. 
										Click image for Danny Epp's project.</p>`,
                image: "/images/step.webp",
              },
              {
                title: "Forms Deep Footings",
                body: `<p>Fastfoot<sup>®</sup> is ideal for deep footings and commercial pads. Form footings up to 4' deep. Eliminate expensive and heavy plywood and eliminate expensive re-cycling of formwork.</p>`,
                image: "/images/deep-footings.webp",
              },
              {
                title: "Prevents Ground Water Contamination",
                body: `<p>Fastfoot<sup>®</sup> is a closed form, preventing cement fines from entering the water table.</p>`,
                image: "/images/prevents-ground-water-contamination.webp",
              },
              {
                title: "Stronger Concrete",
                body: `<p>As the picture above shows, Fastfoot<sup>®</sup> prevents the footing concrete from being 
										contaminated by mud and water, leading to a stronger concrete. In the summer, 
										Fastfoot<sup>®</sup> prevents rapid evaporation of moisture in the sides and bottom of the footing. 
										This ensures adequate moisture for proper hydration of the cement particles.</p>`,
                image: "/images/prevents-rapid-desiccation.webp",
              },
            ],
          },
          {
            id: "installation",
            menuItem: {
              en: {
                title: "Fastfoot Residential Installation",
                menu: "Installation",
                url: urls.fastFoot.residential.installation,
                metaTitle: "Fastfoot Residential Installation - Step-by-Step Guide",
                metaDescription: "Follow our easy-to-understand installation guide for Fastfoot® residential footing forms. Learn how to efficiently install your Fastfoot forms and ensure a secure and durable foundation for your home.",
              },
            },
            category: "fastFootForms",
            videos: [],
            articles: [
              {
                en: {
                  title: ``,
                  body: residentialInstallPage("en"),
                  image: "",
                },
              },
            ],
          },
          {
            id: "estimator",
            menuItem: {
              en: {
                title: "Fastfoot Residential Estimator",
                menu: "Estimator",
                url: urls.fastFoot.residential.estimator,
                metaTitle: "Fastfoot Residential Estimator - Calculate Your Footing Costs",
                metaDescription: "Use the Fastfoot® Residential Estimator to calculate the cost of your footing forms. Compare Fastfoot to traditional lumber and other methods to make an informed decision for your home foundation.",
              },
            },
            category: "fastFootForms",
            articles: [
              {
                title: "",
                body: ffCostEstimator("en", "residential"),
                image: "",
              },
            ],
          },
          {
            id: "level-r",
            menuItem: {
              en: {
                title: "Level-R Overview",
                menu: "Level-R",
                url: "level-r/overview",
                metaTitle: "Level-R Overview - Advanced Concrete Footing Support",
                metaDescription: "Level-R offers enhanced support for concrete footings. Explore its features and benefits for residential and commercial construction projects. Ensure a stronger, more reliable foundation with Level-R.",

              },
            },
            category: "fastFootForms",
            articles: [],
          },
          {
            id: "rising-damp",
            menuItem: {
              en: {
                title: "Fastfoot Rising Damp",
                menu: "Rising damp",
                url: urls.fastFoot.residential.risingDamp,
                metaTitle: "Fastfoot Rising Damp - Prevent Moisture in Concrete Footings",
                metaDescription: "Learn how Fastfoot® helps prevent rising damp in your concrete footings. Our solutions protect foundations from ground moisture, ensuring a drier and healthier environment inside your home.",
              },
            },
            category: "fastFootForms",
            videos: [
              {
                video: "https://www.youtube.com/embed/w6iiwvi1tx4?autoplay=1",
                title: "Rising Damp in Concrete Footings",
                splashScreen: "/images/rising-damp-in-concrete-footings.webp",
              },
            ],
            articles: [
              {
                en: {
                  title: "",
                  body: `<lite-youtube videoid=w6iiwvi1tx4></lite-youtube>`,
                },
              },
              {
                en: {
                  title: "Understanding Rising Damp",
                  body: `<div class="rising-damp-block">
												<p>Rising damp is the wicking of water through the footing into the concrete wall, leading to evaporation inside the building. This increases moisture, causing dampness and mold.</p>
												<p>Unlike liquid water entering a wall, rising damp results in a chronic musty smell that worsens with more moisture exposure.</p>
												<p>The worst cases occur with water ponding at the footing level due to poor soil slope, improperly placed drain tiles, or lack of sub-footing drainage.</p>
												<p>Even without ponding, rising damp happens when unprotected footings are exposed to damp ground. Hygroscopic concrete wicks ground moisture into the foundation, which evaporates inside. Fastfoot<sup>®</sup> prevents this wicking, ensuring a drier, healthier indoor environment.</p>
											</div>`,
                  image: "/images/rising-damp.webp",
                },
              },
              {
                en: {
                  title: "Preventing Rising Damp",
                  body: `<div class="rising-damp-block">
												<p>Rising damp is prevented by isolating the concrete footing from ground moisture. While foundation walls are typically protected with a damp-proof membrane, footings are often neglected. Yet, most moisture is found at the bottom of the excavation, where the footings are.</p>
												<p><span>To prevent water ponding on impervious subsoils, follow these steps:</span>
													<ul class="number-list">
														<li>Grade the excavation slightly to avoid ponding.</li>
														<li>Place a non-wicking drainage layer under the footing to allow groundwater to exit to the perimeter drain system.</li>
														<li>Ensure the drainpipe is below the bottom of the footing.</li>
														<li>Use Fastfoot<sup>®</sup> to protect the footing from ground moisture on all sides.</li>                                
													</ul>
												</p>
											</div>`,
                  image: "/images/rising-damp-1.webp",
                },
              },
              {
                en: {
                  title: "Moisture in Basements & Crawlspaces",
                  body: `<div class="rising-damp-block">
												<p>Both water ponding and rising damp is evident in this crawlspace in Surrey BC. Note the effervescence on the stem walls from rising damp travelling up through the footing, into the stem wall and evaporating inside the crawl space.</p>
												<p>Poor drainage, an improperly sloped excavation, and no sub-footing drainage layer caused water ponding. No damp proof membrane around the footing resulted in rising damp. </p>
												<p>Humidity levels are 100%, resulting in mold and mildew and a very unhealthy envirnoment for the homeowner.</p>
											</div>`,
                  image: "/images/basement-waterproofing.webp",
                },
              },
              {
                en: {
                  title: 'CMHC Report "Mold in Finished Basements"',
                  body: `<div class="rising-damp-block">
												<p>CMHC (Canada Mortgage and Housing Corporation, Canada's National Housing Agency), conducted a survey of 405 houses in the Ottawa region of Ontario, Canada. The objective of the survey was "to determine whether typical 'finished' basements are contributing to poor indoor air quality as a result of mold growth in the finishing materials". About half of the 405 houses "had signs of moisture in the basement". The study then selected 22 for further investigation. Molds were found in 18 of the 22 houses, or 82%. Mold samples were taken from 16 of the 18 houses.</p>
												<p>In 100% of those houses, "molds with properties that are harmful to humans were found."</p>
											</div>`,
                  doc: "/docs/cmhc-molds-in-finished-basements.pdf",
                  image: "/images/molds-in-finished-basements.webp",
                },
              },
            ],
          },
          {
            id: "projects",
            menuItem: {
              en: {
                title: "Fastfoot Residential Projects",
                menu: "Projects",
                url: urls.fastFoot.residential.projects,
                metaTitle: "Fastfoot Residential Projects - Real World Applications",
                metaDescription: "Browse through real-world Fastfoot® residential projects. See how our footing solutions have been successfully implemented in homes across various locations and terrains.",
              },
            },
            category: "fastFootForms",
            articles: [],
          },
          {
            id: "specifications",
            menuItem: {
              en: {
                title: "Fastfoot Residential Specifications",
                menu: "Specifications",
                url: urls.fastFoot.residential.specifications,
                metaTitle: "Fastfoot Residential Specifications - Product Details",
                metaDescription: "Access detailed specifications for Fastfoot® residential footing forms, including roll size, corner size, packaging, and technical documentation for a better understanding of our product.",
              },
            },
            category: "fastFootForms",
            articles: [
              {
                en: {
                  title: "Roll Size & Packaging",
                  body: rollSize("en"),
                  image: "/images/fastfoot-and-box.webp",
                },
              },
              {
                en: {
                  title: "Corner Size & Packaging",
                  body: cornerSize("en"),
                  image: "/images/full-corner.webp",
                },
              },
              {
                en: {
                  title: `Fastfoot<sup>®</sup> Library`,
                  body: specLibs("en"),
                  image: "",
                },
              },
            ],
          },
        ],
      },
      {
        id: "commercial",
        menuItem: {
          en: {
            title: "Commercial",
          },
        },
        content: [
          {
            id: "overview",
            menuItem: {
              en: {
                title: "Fastfoot Commercial Overview",
                menu: "Overview",
                url: urls.fastFoot.commercial.overview,
                metaTitle: "Fastfoot Commercial Overview - Efficient and Cost-Effective Formwork",
                metaDescription: "Discover the benefits of using Fastfoot® for commercial concrete formwork. Save on costs and reduce installation time compared to traditional plywood. Learn about the advantages, including minimal bracing and faster deployment.",
              },
            },
            category: "fastfootCommercial",
            images: ["/images/fastfoot-commercial-formwork.webp"],
            videos: [],
            articles: [
              {
                title: `Commercial Pads: Fastfoot<sup>®</sup> vs Plywood`,
                body: `<div><p>Fastfoot<sup>®</sup> and a single 2x8 screed board hinged at each corner for rapid deployment and
									stripping, weighs just 4.6 pounds a running foot.</p><p>Plywood with the 2x4 frame weighs
									over 14 pounds a running foot, over three times that of Fastfoot<sup>®</sup>. Using Fastfoot<sup>®</sup> reduces
									wear and tear on your crew, and keeps your project ahead of schedule.<p></div>`,
                image: "",
              },
              {
                title: `Cost Comparison: Fastfoot<sup>®</sup> vs Plywood`,
                body: `<p>Fastfoot<sup>®</sup> is dramatically less expensive than using plywood to form commercial pads.
									<a href="/${lang}/${urls.fastFoot.commercial.estimator}">Fastfoot Commercial cost comparison tool</a>.</p>`,
                image: "/images/fastfoot-commercial-fastfoot-vs-polywood.webp",
              },
              {
                title: "Minimal Bracing",
                body: `<div><p>In the photo below the contractor uses minimal bracing: two single stakes on each face,
									with no lateral support on bottom. Lateral pressures are reduced 50% with Fastfoot<sup>®</sup>, with no
									lateral pressure at the bottom. This makes installation and stripping fast and lowers costs significantly.</p>
									<p>With plywood, concrete pressure is highest at the bottom, requiring significant support
									at base to prevent blowouts.</p>
									<p>Note in the photo above how the contractor has shoveled sand around the base to prevent
									blowouts. This is never required with Fastfoot<sup>®</sup>.</p></div>`,
                image: "/images/fastfoot-commercial-minimal-bracing.webp",
              },
              {
                title: "Screed Board Adjustment",
                body: `<div><p>With Fastfoot<sup>®</sup> the 2x8 is adjusted to the exact elevation of the top of the pad, with
									fabric filling between the screed board and ground. Screeding is fast, easy and efficient.</p>
									<p>With plywood, the top of the form is seldom the top of the pad, requiring the installation
									of a 1x2 leveling strip around the inside. Concrete placement and finishing is difficult and time-consuming.</p>
									<p>Note the form blowout, requiring rapid deployment of broken concrete from a previous plywood form failure.</p></div>`,
                image:
                  "/images/fastfoot-commercial-screed-board-adjustment.webp",
              },
              {
                title: "Pour Size",
                body: `<div><p>As Fastfoot<sup>®</sup> is 'sacrificed', there are no inventory limitations on the size of the pour.
									The left photo (with bracing removed) shows the first pour; the right photo is the second pour.
									The number of pads poured each day was a function of the speed of the concrete pump and the supply
									of concrete, not form inventory.</p>
									<p>With plywood, the size of the pour is constrained by the plywood in stock. If this project
									was formed with plywood, 18,000 pounds of form materials would have been required for each of
									the two pours, and a crane to move the panels across the site.</p></div>`,
                image: "/images/fastfoot-commercial-pour-size.webp",
              },
              {
                title: "Rising Damp Prevention & Ground Water Contamination",
                body: `<div><p>Concrete is hydroscopic, wicking up groundwater which then enters the interior of the
									structure. This is why underground garages have very high humidity levels. Note the damp color
									of the sand, indicating moisture wicking up from the water table below.</p>
									<p>Fastfoot<sup>®</sup> is a damp proof membrane which prevents ground moisture wicking up into the concrete,
									thereby providing a dry and healthy indoor air environment. The membrane also prevents cement
									fines leaching into the groundwater table.</p>
									<p>Plywood is an open form providing NO protection against ground moisture, leading to damp
									concrete for the life of the building. Cement fines contaminate the water table.</p>
									<p><a href="/${lang}/${urls.fastFoot.residential.risingDamp}">Click here for additional information on rising damp</a></p></div>`,
                image: "/images/fastfoot-commercial-rising-damp.webp",
              },
              {
                title: "Cost of Materials, Cost of Recycling",
                body: `<div><p>Fastfoot<sup>®</sup> is an inexpensive form that uses minimal resources. The small amount of lumber
									is protected by fabric and therefore lasts indefinitely. No recycling costs with Fastfoot<sup>®</sup>.</p>
									<p>Plywood forms are heavy and expensive. They have a short life as a temporary form, then must
									be stripped, cleaned, treated, transported, stored, and ultimately discarded in a land fill.
									This requires significant labor and energy.</p></div>`,
                image: "/images/fastfoot-commercial-cost-of-materials.webp",
              },
            ],
          },
          {
            id: "installation",
            menuItem: {
              en: {
                title: "Fastfoot Commercial Installation",
                menu: "Installation",
                url: urls.fastFoot.commercial.installation,
                metaTitle: "Fastfoot Commercial Installation - Easy and Efficient Setup",
                metaDescription: "Follow our comprehensive guide to installing Fastfoot® commercial formwork. Learn how to quickly and effectively install Fastfoot for your commercial concrete needs, ensuring a secure foundation every time.",
              },
            },
            category: "fastfootCommercial",
            images: [],
            videos: [],
            articles: [
              {
                en: {
                  title: ``,
                  body: commercialInstallPage("en"),
                },
              },
            ],
          },
          {
            id: "estimator",
            menuItem: {
              en: {
                title: "Fastfoot Commercial Estimator",
                menu: "Estimator",
                url: urls.fastFoot.commercial.estimator,
                metaTitle: "Fastfoot Commercial Estimator - Calculate Your Formwork Costs",
                metaDescription: "Use the Fastfoot® Commercial Estimator to calculate the cost of using Fastfoot for your commercial projects. Compare Fastfoot to traditional plywood and other formwork options to find the most cost-effective solution.",
              },
            },
            category: "fastfootCommercial",
            articles: [
              {
                title: "",
                body: ffCostEstimator("en", "commercial"),
                image: "",
              },
            ],
          },
          {
            id: "projects",
            menuItem: {
              en: {
                title: "Fastfoot Commercial Projects",
                menu: "Projects",
                url: urls.fastFoot.commercial.projects,
                metaTitle: "Fastfoot Commercial Projects - Real World Applications",
                metaDescription: "Explore real-world examples of Fastfoot® used in commercial projects. See how our formwork solutions have been successfully implemented in various commercial construction projects.",
              },
            },
            category: "fastFootCom",
            articles: [],
          },
          {
            id: "specifications",
            menuItem: {
              en: {
                title: "Fastfoot Commercial Specifications",
                menu: "Specifications",
                url: urls.fastFoot.commercial.specifications,
                metaTitle: "Fastfoot Commercial Specifications - Detailed Product Information",
                metaDescription: "Access the detailed specifications for Fastfoot® commercial formwork, including sizes, packaging, and technical documentation. Learn everything you need to know about Fastfoot to make the best choice for your commercial construction needs.",
              },
            },
            articles: [
              {
                en: {
                  title: "Roll Size & Packaging",
                  body: rollSize("en"),
                  image: "/images/fastfoot-and-box.webp",
                },
              },
              {
                en: {
                  title: `Fastfoot<sup>®</sup> Library`,
                  body: specLibs("en"),
                  image: "",
                },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "fastTube",
    menuItem: {
      en: {
        title: "Fast-Tube",
        menu: "Fast-Tube",
        underTitle: "Column Forms",
        shortDescription: `<a class="product-link" href="/${lang}/${urls.fastTube.overview}">Fast-Tube™</a> is a utility fabric column form for forming round concrete columns. Manufactured from high strength polyethylene. Installation, pouring and stripping is quick and easy.`,
      },
    },
    image: "/images/ft-form.webp",

    isProduct: true,
    content: [
    	{
			id: "overview",
			category: "fastTube",
			menuItem: {
				en: {
					title: "Fast-Tube Overview",
					menu: "Overview",
					url: urls.fastTube.overview,
					metaTitle: "Fast-Tube Overview - Space-Saving Column Forms",
					metaDescription: "Fast-Tube™ is a high-strength polyethylene utility fabric column form designed for round concrete columns. With easy installation, pouring, and stripping, it offers significant space and weight savings compared to traditional cardboard forms.",
				},
			},
			body: `
				<div class="article_wrapper">
					<div class="article-content-wrapper">
						<div class="false article-text-block text-35" }="">
							<h3 class="article_title">Space</h3>
							<div class="article_text">
								<ul>
									<li>1% the space</li>
									<li>10% the weight</li>
								</ul>
							</div>
						</div>
						<div class="false article-media-block media-65" }="">
							<video class="article-video" loop="" autoplay="" muted="" playsinline="">
								<source src="/videos/space.mov" type="video/mp4">
							</video>
						</div>
					</div>
				</div>
				<div class="article_wrapper">
					<div class="article-content-wrapper">
						<div class="false article-text-block text-35" }="">
							<h3 class="article_title">No Waste</h3>
							<div class="article_text">
								<div>Cut to length</div>
							</div>
						</div>
						<div class="false article-media-block media-65" }="">
							<video class="article-video" loop="" autoplay="" muted="" playsinline="">
								<source src="/videos/waste.mov" type="video/mp4">
							</video>
						</div>
					</div>
				</div>
				<div class="article_wrapper">
					<div class="article-content-wrapper">
						<div class="false article-text-block text-35" }="">
							<h3 class="article_title">Waterproof</h3>
						</div>
						<div class="false article-media-block media-65" }="">
							<video class="article-video" loop="" autoplay="" muted="" playsinline="">
								<source src="/videos/waterproof.mov" type="video/mp4">
							</video>
						</div>
					</div>
				</div>
			`						,
			images: [],
			videos: [],
			articles: [
				{
					en: {
						body: `
							<div >
								<p>Fast-Tube™ is a utility fabric column form for forming round concrete columns. Manufactured from high strength polyethylene,
									Fast-Tube™ comes on rolls 100' in length for diameters from 8" to 18".
									Installation, pouring and stripping is quick and easy.</p>
								<p>Fast-Tube is manufactured from a woven high density PE. Minor tension
									differences in the fabric scrim can lead to slight twisting and
									wrinkles.</p>
								<p>Sustainable Advantages:</p>
								<ul class="disc-list">
									<li>Economic, see spreadsheet below</li>
									<li>No waste: cut any length from 100' roll</li>
									<li>Ships flat, 1% the space of cardboard tubes</li>
									<li>Light weight, 10% the weight of cardboard tubes</li>
									<li>Strips in seconds</li>
									<li>Recycle as under slab membrane</li>
									<li>Undamaged by rain and moisture</li>
								</ul>
							</div>
						`,
					},
				},
			],
    	},
    	{
			id: "installation",
			category: "fastTube",
			menuItem: {
				en: {
					title: "Fast-Tube Installation",
					menu: "Installation",
					url: urls.fastTube.installation,
					metaTitle: "Fast-Tube Installation - Easy and Efficient Column Form Setup",
					metaDescription: "Learn how to install Fast-Tube™ column forms in just a few simple steps. This guide will walk you through cutting, stapling, bracing, and pouring, ensuring fast and efficient setup for your concrete columns.",
				},
			},
			images: [],
			videos: [],
			articles: [
				{
					en: {
						title: `<span>1.</span> CUT FAST-TUBE TO LENGTH`,
						body: `<div class="text-start">
											<p>Unroll Fast-Tube on ground and cut to length using a utility knife and carpenter’s square.</p>
											<p>Some contractors cut Fast-Tube extra long, then slit the fabric horizontally at the correct height once the tube is installed and braced.</p></div>`,
						localVideo: "/videos/cut-the-length",
					},
				},
				{
						en: {
						title: `<span>2.</span> STAPLE FAST-TUBE TO 2X4`,
						body: `<div class="text-start"><p>Cut two straight 2x4s slightly longer than the cut Fast-Tube.</p>
											<p>Staple (or nail) the alignment tab at bottom end of 2x4, with weld directly against 2x4 edge.</p>
											<p>Continue stapling 18” on center along full length of alignment tab.</p></div>`,
						localVideo: "/videos/stuple-fast-tube",
					},
				},
				{
					en: {
						title: `<span>3.</span> NAIL SECOND 2X4 TO FIRST`,
						body: `<div class="text-start"><p>Nail second 2x4 to first, sandwiching the alignment tab. Double nail at base and top, then 18” on center. 
											Locate nails near edge to better grip tab.</p></div>`,
						localVideo: "/videos/nail-fast-tube",
					},
				},
				{
					en: {
						title: `<span>4.</span> SET UP & BRACE`,
						body: `<div class="text-start"><p>Carefully slide Fast-Tube over rebar cage, ensuring no tearing of fabric. Plumb and brace.</p></div>`,
						localVideo: "/videos/set-up-fast-tube",
					},
				},
				{
					en: {
						title: `<span>5.</span> POUR CONCRETE`,
						body: `<div class="text-start"><p>Insert pump hose down center of tube, withdraw as tube fills. Do not pull on top edge as this can unpeel weld.</p>
											<p>Maximum slump 5”. Vibrate with hands on outside or with 1” pencil vibrator.</p></div>`,
						localVideo: "/videos/pour-concrete",
					},
				},
				{
					en: {
						title: `<span>6.</span> Strip Fast-Tube™`,
						body: `<div class="text-start"><p>Remove 2x4" material, and pull on the alignment tab. Fast-Tube™ can be reused as an underslab membrane.</p></div>`,
						localVideo: "/videos/stripping",
					},
				},
				{
					en: {
						title: "PDF Instruction",
						body: `<p><a href="/docs/fast-tube-installation.pdf" onclick="window.open(this.href,'_blank');return false;">Download the Fast-Tube installation PDF brochure</a></p>`,
						image: "",
					},
				},
        	],
    	},
    	{
			id: "cost-effective",
			category: "fastTube",
			menuItem: {
				en: {
					title: "Fast-Tube Cost Effective",
					menu: "Cost Effective",
					url: urls.fastTube.costEffective,
					metaTitle: "Fast-Tube Cost Effective - Economical Concrete Column Solution",
					metaDescription: "Discover how Fast-Tube™ is the most cost-effective solution for forming concrete columns. From reducing material waste to faster installation, Fast-Tube helps you save money on your construction projects.",
				},
			},
			images: [],
			videos: [],
			articles: [
				{
					en: {
					title: "",
					body: constEffectiveFrom("en"),
					},
				},
			],
		},
		{
			id: "projects",
			menuItem: {
				en: {
					title: "Fast-Tube Projects",
					menu: "Projects",
					url: urls.fastTube.projects,
					metaTitle: "Fast-Tube Projects - Successful Implementations",
					metaDescription: "Explore real-world examples of Fast-Tube™ in action across various construction projects. See how it’s used to form concrete columns quickly and efficiently, with great results.",
				},
			},
			category: "fastTube",
			images: [],
			videos: [],
			articles: [],
		},
		{
			id: "specifications",
			category: "fastTube",
			menuItem: {
				en: {
					title: "Fast-Tube Specifications",
					menu: "Specifications",
					url: urls.fastTube.specifications,
					metaTitle: "Fast-Tube Specifications - Detailed Product Information",
					metaDescription: "Get detailed specifications for Fast-Tube™ column forms, including sizes, packaging, and maximum pour heights. Learn everything you need to know about Fast-Tube’s capabilities and packaging options.",
				},
			},
			images: [],
			videos: [],
			articles: [
				{
					en: {
						title: "Maximum pour height",
						body: `<div><p>The table below shows the maximum Fast-Tube height based on its diameter. Assuming a 5" slump and a continuous pour.</p>
												${maxPourTable("en")}
											</div>`,
						image: "",
					},
				},
				{
					en: {
						title: "Sizes & Packaging",
						body: `<div>
												<p>Fast-Tube™ comes on 10' and 100' rolls and is available in diameters from 8" to 18".</p>
												${sizeTable("en")}
											</div>`,
						image: "/images/fast-tube-packaging.webp",
					},
				},
				{
					en: {
						title: "Fast-Tube™ Brochures",
						doc: "/docs/fast-tube-brochure.pdf",
						body: `<p>These are tri-folded, full colour, folded size is 4-1/4" x 9". Click on image to download the PDF.</p>`,
						image: "/images/fast-tube-brochure.webp",
					},
				},
				{
					en: {
						title: "Fast-Tube Dealer Binder",
						doc: "/docs/fast-tube-dealer-binder.pdf",
						body: `<p>If you click on this image, an eight page PDF file can be opened up and printed.</p>`,
						image: "/images/fast-tube-dealer-binder.webp",
					},
				},
				{
					en: {
						title: "Fast-Tube™ Lumberyard Display",
						doc: "/docs/fast-tube-display.pdf",
						body: `
												<p>48x24" display showcases 10" Fast-Tube with a Styrofoam column inside to give the illusion of concrete. Click on image to download the PDF.</p>`,
						image: "/images/fast-tube-display.webp",
					},
				},
			],
		},
		{
			id: "faq",
			category: "fastTube",
			menuItem: {
				en: {
					title: "Fast-Tube FAQ",
					menu: "FAQ",
					url: urls.fastTube.faq,
					metaTitle: "Fast-Tube FAQ - Frequently Asked Questions",
					metaDescription: "Get answers to your most common questions about Fast-Tube™. From installation tips to product specifications, our FAQ section provides valuable information to help with your concrete column projects.",
				},
			},
			images: [],
			videos: [],
			articles: [
				{
					title: "",
					body: `<div class="faq-wrapper">${faqContent
					.map((faq) => createFaqBlock(faq["en"].title, faq["en"].body))
					.join("")}</div>`,
				},
			],
		},
    ],
  },
  {
    id: "monopour",
    menuItem: {
      en: {
        title: "ICF Monopour",
        menu: "Monopour",
        underTitle: "One-Step Concrete Pour",
        shortDescription: `
			<div>
				<p>ICF Monopour is a one-step concrete pour for both footings and walls, streamlining the foundation process and making it faster and more efficient. Learn more about the <a class="product-link" href="/${lang}/${urls.monopour.mpss.overview}">MPSS</a> and <a class="product-link" href="/${lang}/${urls.monopour.mphd.overview}">MPHD</a> systems.</p>
			</div>

		`
      },
    },
    image: "/images/monopour-hd.webp",
    isProduct: true,
    content: [
      {
        id: "mpss",
        menuItem: {
          en: {
            title: "MPSS",
            menu: "MPSS",
          },
        },
        content: [
          {
            id: "overview",
            category: "monopour",
            menuItem: {
              en: {
                title: "MPSS Overview",
                menu: "Overview",
                url: urls.monopour.mpss.overview,
                metaTitle: "MPSS Overview - Efficient Monopour Side Support System",
                metaDescription: "Learn about the MPSS (Monopour Side Support System), designed for forming and pouring concrete footings and walls simultaneously. Discover the benefits, including drill adjustable side supports and easy installation with Fastfoot®.",
              },
            },
            images: ["/images/fab-form-monopour.webp"],
            videos: [
              {
                video: "https://www.youtube.com/embed/5YqJLWg8LUQ?autoplay=1",
                title: `Fastfoot<sup>®</sup> Monopour Benefits`,
                splashScreen: "/images/fastfoot-monopour-benefits-youtube.webp",
              },
            ],
            articles: [
              {
                title: "Understanding the Monopour System",
                body: `<div>
										<p>The system consists of four components:</p>
										<ol>
											<li>Drill adjustable side supports used to hold the ICF block the 
											footing height above the ground;</li>
											<li>Fastfoot fabric (MP corners, MP Ts and regular straights) used to contain and form 
											the concrete footing under the ICF block;</li>
											<li>The ICF block itself;</li>
											<li>Zont bracing used to align and hold the foundation in position.</li>
										</ol>
										<p><a href="/${lang}/${urls.monopour.mpss.installation}">The installation manual, including the calculation of the fold distance</a>.</div>`,
                image: "/images/fab-form-mp-cross-section-feet.webp",
              },
              {
                title: "Drill Adjustable Side Supports",
                body: `<div><p>Pairs of patented MP side supports are screwed to the plastic web of the ICF block at 
										approximately 4' on center. An electric drill is used to quickly adjust wall height. The MP 
										side supports work with all horizontal ICF blocks with ties molded into the EPS</p>
										<p>The MP side supports consist of a sheet metal attachment flange, 1/2" diameter threaded 
										adjuster and an injection-molded plastic foot pad. The flange is made of solid 10 gauge 
										steel and has a metal tab that connects with the bottom of the ICF web, preventing the side 
										support from sliding up the block. This ensures an accurate wall height adjustment.</p>
										<p>The two part plastic pad allows the set screw to rotate in the foot during the adjustment 
										process and allows for 12 degrees of angular change in all directions to accommodate uneven ground.</p></div>`,
                image: "/images/fab-form-mp-side-support.webp",
              },
              {
                title: `Special Sewn Fastfoot<sup>®</sup> Corners & T-Junctions`,
                body: `<p>Fastfoot<sup>®</sup> is screw attached using a plywood batten to the bottom edges of the ICF 
										components, ensuring the footing concrete is completely protected from rising damp. Pre-sewn 
										corners and T-junctions must be used as you are forming the bottom, sides and top of the footing.</p>`,
                image: "/images/fab-form-mp-corner.webp",
              },
              {
                title: "Zont™ Bracing",
                body: `<p>The bracing was designed specifically for use with the monopour system. Scaffolding 
										loads are transferred directly to the ground through the strongback, without interfering 
										with the footing concrete. The bracing is simple and cost effective, consisting of Zont™ 
										brackets, Zuckle™ wall aligners, ZAT catwalk brackets and site available 2x4s. Click on the 
										image above for more information.</p>`,
                image: "/images/fab-form-zont-bracing-cirrus.webp",
              },
            ],
          },
          {
            id: "installation",
            category: "monopour",
            menuItem: {
              en: {
                title: "MPSS Installation",
                menu: "Installation",
                url: urls.monopour.mpss.installation,
                metaTitle: "MPSS Installation - Step-by-Step Guide for Monopour System",
                metaDescription: "Follow this detailed guide for installing the MPSS (Monopour Side Support System) with Fastfoot®. Learn the steps to install, adjust, and pour concrete with ease for a stronger foundation.",
              },
            },
            images: [],
            videos: [
              {
                video: "https://www.youtube.com/embed/hd1QvjgTuZg?autoplay=1",
                title: "Insulated Concrete Form Monopour Installation",
                splashScreen:
                  "/images/insulated-concrete-form-monopour-installation-youtube.webp",
              },
            ],
            articles: [
              {
                title: "",
                body: `<div>
										<p>Fastfoot® Monopour allows the foundation wall and footing to be poured at the same time, eliminating the cold joint and providing a stronger foundation. The MP can also be used without Fastfoot (with trenched footings).</p>
										<p><a href="/docs/mpss-installation-guide.pdf">Momopour Side Support Installation PDF Gide</a></p>
										</div>
										`,
                image: "",
              },
              {
                title: "HELIX",
                body: `
										<p>Helix® is recommended for three reasons: first, vertical loading on the MP side supports is minimized; second, wall alignment is improved (no steel to restrict movement); and third, rebar labor is eliminated.</p>									`,
                image: "",
              },
              {
                title: "1. BATTER BOARDS & STRINGLINES",
                body: `<div>
										<p>As side supports adjust from 7" to 12", excavation must be level.</p>
										<p>Setup batter boards and stringlines around perimeter with string located exactly 2" outside ICF and about 4" above top of footing. Loop end of string so it can be quickly taken down when not needed.</p>
										<p>Using stringline as guide, spray paint centerline on the ground to position Fastfoot®. </p>
									</div>`,
                image: "/images/mpss-monopour-installation-1.webp",
              },
              {
                title: "2. FASTFOOT",
                body: `
										<p>Place special monopour corners and Ts in position, then run Fastfoot standard between with overlap equal to twice the web spacing, use sheathing tape on overlap.</p>
									`,
                image: "",
              },
              {
                title: "3. MP SIDE SUPPORTS",
                body: `<div>
										<p>Adjust height of each support pad to about 1" less than footing height (easy to adjust upwards, difficult to adjust downwards).</p>
										<p>Install one pair of side supports on each 4' block at web closest to end by removing foam (1-1/8" x 6-3/4") directly over plastic web (for 8' blocks attach 2 pairs, one at one end and one near middle). Screw to internal tie with two #8 x 1" screws provided with protruding metal tab touching bottom of plastic web.</p>
										<p>On corner blocks install one pair of supports close to corner (see drawing 4).</p>
									</div>`,
                image: "/images/mpss-monopour-installation-3.webp",
              },
              {
                title: "4. INSTALL ICF AROUND PERIMETER",
                body: `
										<p>Install first ICF corner in position and run two beads of non expansive foam glue to vertical edges on the short end. Attach adjacent block with four vertical joint clips (VJCs). Place fiber tape “X” over joint on both sides to prevent vertical slipage.</p>
									`,
                image: "/images/mpss-monopour-installation-4.webp",
              },
              {
                title: "5. ROUGH LEVEL",
                body: `
										<p>Using laser and 2' level, adjust height of corner and adjacent block to about 1/4” below final height, ensure blocks are plumb and 2” off stringline. Don’t be too accurate at this stage. Continue adding blocks and rough leveling around perimeter.</p>
									`,
                image: "/images/mpss-monopour-installation-5.webp",
              },
              {
                title: "6. MARRIAGE LINE",
                body: `<div>
										<p>A “marriage line” is required to obtain exact corner to corner distance. Cut each marriage line block to length (see working drawing). Use Zap straps or 1x4 strapping to hold joint after gluing.</p>
										<p>If not using Helix, install horizontal rebar on top of the first layer of blocks. Install second layer of blocks running beads of glue on horizontal and vertical joints. Use two vertical joint clips at the top of each vertical joint. Stagger upper vertical joint two web distances from the vertical joint below.</p>
										<p>Install rebar on top of second level. If footing steel is required, attach to side supports with tie wire or 8” zap straps. Install third layer of block and steel if required.</p>
									</div>`,
                image: "/images/mpss-monopour-installation-6.webp",
              },
              {
                title: "7. ATTACH FASTFOOT",
                body: `
										<p>The “fold distance” is the distance from the centre line to the top of the plywood batten. Use the calculator on the installation page of our website to determine this distance. Fold Fastfoot® over the plywood batten and attach to web using #8 x 1-1/2” deck screws. Do not use the pre printed lines on the fabric as they are for conventional footings.</p>
									`,
                image: "/images/mpss-monopour-installation-7.webp",
              },
              {
                title: "8. INSTALL ZONT BRACING",
                body: `<div>
										<p>Install pairs of Zonts about 6' on centre, one at top of lower block and one directly above, on top of third block. Place walers and strongbacks in position around the perimeter.</p>
										<p>Drive a stake adjacent to each strong back, move wall until it is exactly 2" off string line (ensure wall is plumb), then screw stake to strongback.</p>
										<p>Screw Zuckle™ to one end of a suitably sized a 2x4, then screw Zuckle near the top of strongback, or if a walkway will be installed, just under 2x10. Ensure Zuckle is in mid-range of adjustment and double stake end of 2x4 kicker to ground. Plumb strong back exactly with electric drill on Zuckle™. Your wall is now rigidly held in exact X-Y position.</p>
									</div>`,
                image: "/images/mpss-monopour-installation-8.webp",
              },
              {
                title: "9. FINAL HEIGHT ADJUSTMENT",
                body: `<div>
										<p>Back off Camlocks™ to allow wall height adjustment. Use drill on bracing side to raise wall until laser sensor sounds. Tighten Camlocks. Then person on opposite side uses clutched drill (on low setting) to lower pad until clutch slippage occurs, indicating load taken by side support (do not over lower or wall can lift).</p>
										<p>Screw all battens next to side supports to complete Fastfoot.</p>
										<p>Continue building the ICF wall to the required height, installing catwalk if over 6’ in height (see bracing instructions on web).</p>
										<p>Set up stringlines on the top of the wall using 1x2 spacers, and adjust Zuckles to ensure the wall is straight between the corners. Check diagonal distances  as detailed on working drawings.</p>
									</div>`,
                image: "",
              },
              {
                title: "10 - CONCRETE POUR",
                body: `<div>
										<p>Ensure eccentric pressures are supported appropriately, eg: brace the outside of any “T”, including the footing.</p>
										<p>If pumping Helix reinforced concrete ensure hose diameter is least 3”. Ensure lifts are properly consolidated.</p>
										<p>Order concrete with 5 to 6" slump, concrete should flow into footing.</p>
										<p>Pour the footing + 6" of the first block. Do NOT overfill the wall or the footing fabric will LIFT the wall. Allow sufficient time for the footing concrete to “go off”. In summer this will take no time; in winter allow up to one hour.</p>
										<p>Zuckle adjust top of wall to each stringline. Laser screed top of wall to ensure exact elevation.</p>
										</div>`,
                image: "",
              },
              {
                title: "Determination of Fold Distance",
                body: `<div>
										<div class="image-wrapper">
											<img src="/images/fab-form-mp-graphics-section.webp">
										</div>
										<p>The "fold distance" is the distance from the centre line to the fold at the top of the 
										batten as shown in the diagram above. Do NOT use the preprinted lines on the fabric as they 
										are for conventional footings, not monopoured footings. The location of the fold line is 
										found by completing the calculator below.</p>
										</div>
									`,
                image: "",
              },
              {
                title: "Fold Distance Estimator",
                body: `<div class="margin-auto mt-20">${mpssCalcForm()}
										<p>To understand how this calculator works, 
										<a href="/${lang}/${urls.monopour.mpss.foldLineLocation}">visit the explanation page</a>.</p></div>`,
              },
            ],
          },
          {
            id: "projects",
            category: "monopour",
            menuItem: {
              en: {
                title: "MPSS Projects",
                menu: "Projects",
                url: urls.monopour.mpss.projects,
                metaTitle: "MPSS Projects - Real-World Applications of Monopour System",
                metaDescription: "Explore real-world projects using the MPSS Monopour Side Support System. See how it's been successfully applied in construction to streamline the process of forming concrete footings and walls.",
              },
            },
            images: [],
            videos: [],
            articles: [],
          },
          {
            id: "specifications",
            category: "monopour",
            menuItem: {
              en: {
                title: "MPSS Specifications",
                menu: "Specifications",
                url: urls.monopour.mpss.specifications,
                metaTitle: "MPSS Specifications - Product Details and Sizing",
                metaDescription: "Get detailed specifications for the MPSS (Monopour Side Support System), including sizing, load-bearing capacity, and installation instructions. Understand the components and how to use them in your projects.",
              },
            },
            title: "Specifications",
            body: "",
            images: [],
            videos: [],
            articles: [
              {
                title: "General Description",
                body: `
										<div>
											<p>The Fab-Form Monopour System uses the ICF block itself to form the footing, thereby 
											eliminating all footing forming lumber, stakes, cold joint and double pour.</p>
											<p>Monopour Supports  suspend ICF blocks above the ground at the required footing height.</p>
											<p>Fastfoot<sup>®</sup>  is attached to the bottom of the ICF blocks to form the footing. Sewn corners 
											and T-junctions increase speed of site installation dramatically.</p>
											<p>Fastfoot<sup>®</sup> is GreenSpec<sup>®</sup> listed and Leed<sup>®</sup> point contributing.</p>
										</div>
									`,
                image: "/images/fab-form-mp-stem-wall.webp",
              },
              {
                title: "Drill Adjustable Side Supports",
                body: `
										<div>
											<p>Side supports are attached to the outside of the ICF block by screwing to the internal plastic web. </p>
											<p>MP™ supports consist of a sheet metal attachment flange, 1/2" diameter adjuster, and an 
											injection-molded foot pad that holds the footing rebar in position above the ground. They 
											are compatible with all horizontal ICF blocks with ties molded into the EPS. </p>
											<p>To determine the number of pairs of supports, divide the perimeter distance by 4.</p>
											<p>A 6mm ball-hex bit (one included with each box of side supports) is used with a variable 
											speed portable drill for height adjustment. Pairs of side supports are located 4' on 
											center along the foundation wall.</p>
											<h3>Sizing & Packaging</h3>
											<p>Standard side support (7&quot adjuster - for footing depths from 7&quot; to 12&quot;):</p>
											<ul>
												<li>Each support weights 1.8 pounds</li>
												<li>Box contains 18 supports (9 pairs) and 36 #8 x 1" deck screws (for attaching the MPSSs to the ICF web</li>
												<li>Box weighs 40 pounds</li>
												<li>Box dimensions: 16&quot; x 10&quot; x 9" </li>
											</ul>
											<h3>Installation Instructions</h3>
											<ul>
												<li><a href="/${lang}/${urls.monopour.mpss.installation}">Fastfoot<sup>®</sup> installation page</a></li>
												<li><a href="/${lang}/${urls.monopour.mpss.foldLineLocation}">Understanding 
												how the fold line is determined</a></li>
											</ul>
											<h3>Load Bearing Capacity of each MPSS</h3>
											<ul>
												<li>Each #10 screw has a shear capacity of 150 lbs. going into the ICF web. So the 
												holding power of each MPSS metal flange is 300 lbs.</li>
												<li>The plastic pad has a diameter of 5.4". Assuming the soil has a load bearing capacity 
												of 2,000 lbs per square foot, this means the pad can support 330 pounds load per pad.</li>
												<li>Therefore the capacity of each MPSS is 300 lbs., or 600 lbs. per pair. Note that 
												scaffolding loads do not get transferred to the ICF wall, they go down the strongback 
												directly into the soil. Therefore, the only load on the MPSSs is horizontal steel bars 
												(ICF blocks have minimal weight). Assuming a spacing of the MPSS pairs of 4' on centre, 
												the pairs can accept a load of 150 lbs. per running foot of wall.</li>
											</ul>
										</div>
									`,
                image: "/images/fab-form-mp-side-support.webp",
              },
              {
                title: `Sewn Fastfoot<sup>®</sup> for Corners, T-Junctions, Straight Components`,
                body: `
										<div>
											<p>Fastfoot<sup>®</sup> corners and T-junctions are available in three widths: 50", 62" and 74". 
											To determine the size of footings and corners, go to <a href="/${lang}/${urls.monopour.mpss.fastfootMpManufacture}">
											the footing size calculator available here</a>.</p>
											<p>Fastfoot<sup>®</sup> is custom designed and sewn to fit the components of your project.</p>
										</div>
									`,
                image: "/images/fab-form-presewn-corners.webp",
              },
              {
                title: `Fastfoot<sup>®</sup> Monopour Library`,
                body: `
										<div>
											<h3>Footing Detail</h3>
											<ol>
												<li><a href="/docs/fab-form-footing-detail.pdf" onclick="window.open(this.href,'_blank');return false;">PDF file</a></li>
												<li><a href="/docs/fab-form-footing-detail.DWG" onclick="window.open(this.href,'_blank');return false;">DWG file</a></li>
											</ol>
											<h3>Stem Wall</h3>
											<ol>
												<li><a href="/docs/fab-form-mp-stem-wall.pdf" onclick="window.open(this.href,'_blank');return false;">PDF file</a></li>
												<li><a href="/docs/fab-form-mp-stem-wall.DWG" onclick="window.open(this.href,'_blank');return false;">DWG file</a></li>
											</ol>
											<h3>Full Basement</h3>
											<ol>
												<li><a href="/docs/fab-form-mp-full-basement.pdf" onclick="window.open(this.href,'_blank');return false;">PDF file</a></li>
												<li><a href="/docs/fab-form-mp-full-basement.DWG" onclick="window.open(this.href,'_blank');return false;">DWG file</a></li>
											</ol>
											<h3>CSI Section Format</h3>
											<ol>
												<li><a href="/docs/fab-form-prefab-monopour-csi.pdf" onclick="window.open(this.href,'_blank');return false;">PDF file</a></li>
												<li><a href="/docs/fab-form-prefab-monopour-csi-specifications.doc" onclick="window.open(this.href,'_blank');return false;">WORD 
												file</a> (right click to save)</li>
											</ol>
											<div class="clear"></div>
											<h3>Marketing Materials</h3>
											<ol>
												<li><a href="/docs/fab-form-monopour-brochure.pdf" onclick="window.open(this.href,'_blank');return false;">ICF Monopour Brochure</a></li>
											</ol>
										</div>
									`,
                image: "",
              },
            ],
          },
          //   {
          //     id: "faq",
          //     category: "monopour",
          //     menuItem: {
          //       en: {
          //         title: "FAQ",
          //         url: "monopour/mpss-faq",
          //       },
          //     },
          //     body: "",
          //     images: [],
          //     videos: [],
          //     articles: [
          //       {
          //         title: "General Description",
          //         body: `
          // 								<div>
          // 									<p>The Fab-Form Monopour System uses the ICF block itself to form the footing, thereby
          // 									eliminating all footing forming lumber, stakes, cold joint and double pour.</p>
          // 									<p>Monopour Supports  suspend ICF blocks above the ground at the required footing height.</p>
          // 									<p>Fastfoot<sup>®</sup>  is attached to the bottom of the ICF blocks to form the footing. Sewn corners
          // 									and T-junctions increase speed of site installation dramatically.</p>
          // 									<p>Fastfoot<sup>®</sup> is GreenSpec<sup>®</sup> listed and Leed<sup>®</sup> point contributing.</p>
          // 								</div>
          // 							`,
          //         image: "/images/fab-form-mp-stem-wall.webp",
          //       },
          //       {
          //         title: "Drill Adjustable Side Supports",
          //         body: `
          // 								<div>
          // 									<p>Side supports are attached to the outside of the ICF block by screwing to the internal plastic web. </p>
          // 									<p>MP™ supports consist of a sheet metal attachment flange, 1/2" diameter adjuster, and an
          // 									injection-molded foot pad that holds the footing rebar in position above the ground. They
          // 									are compatible with all horizontal ICF blocks with ties molded into the EPS. </p>
          // 									<p>To determine the number of pairs of supports, divide the perimeter distance by 4.</p>
          // 									<p>A 6mm ball-hex bit (one included with each box of side supports) is used with a variable
          // 									speed portable drill for height adjustment. Pairs of side supports are located 4' on
          // 									center along the foundation wall.</p>
          // 									<h3>Sizing & Packaging</h3>
          // 									<p>Standard side support (7&quot adjuster - for footing depths from 7&quot; to 12&quot;):</p>
          // 									<ul>
          // 										<li>Each support weights 1.8 pounds</li>
          // 										<li>Box contains 18 supports (9 pairs) and 36 #8 x 1" deck screws (for attaching the MPSSs to the ICF web</li>
          // 										<li>Box weighs 40 pounds</li>
          // 										<li>Box dimensions: 16&quot; x 10&quot; x 9" </li>
          // 									</ul>
          // 									<h3>Installation Instructions</h3>
          // 									<ul>
          // 										<li><a href="/${lang}/${urls.monopour.mpss.installation}">Click here for Fastfoot<sup>®</sup> installation page</a></li>
          // 										<li><a href="/fold-line-location">Understanding
          // 										how the fold line is determined</a></li>
          // 									</ul>
          // 									<h3>Load Bearing Capacity of each MPSS</h3>
          // 									<ul>
          // 										<li>Each #10 screw has a shear capacity of 150 lbs. going into the ICF web. So the
          // 										holding power of each MPSS metal flange is 300 lbs.</li>
          // 										<li>The plastic pad has a diameter of 5.4". Assuming the soil has a load bearing capacity
          // 										of 2,000 lbs per square foot, this means the pad can support 330 pounds load per pad.</li>
          // 										<li>Therefore the capacity of each MPSS is 300 lbs., or 600 lbs. per pair. Note that
          // 										scaffolding loads do not get transferred to the ICF wall, they go down the strongback
          // 										directly into the soil. Therefore, the only load on the MPSSs is horizontal steel bars
          // 										(ICF blocks have minimal weight). Assuming a spacing of the MPSS pairs of 4' on centre,
          // 										the pairs can accept a load of 150 lbs. per running foot of wall.</li>
          // 									</ul>
          // 								</div>
          // 							`,
          //         image: "/images/fab-form-mp-side-support.webp",
          //       },
          //       {
          //         title: `Sewn Fastfoot<sup>®</sup> for Corners, T-Junctions, Straight Components`,
          //         body: `
          // 								<div>
          // 									<p>Fastfoot<sup>®</sup> corners and T-junctions are available in three widths: 50", 62" and 74".
          // 									To determine the size of footings and corners, go to <a href="/${lang}/${urls.monopour.mpss.fastfootMpManufacture}">
          // 									the footing size calculator available here</a>.</p>
          // 									<p>Fastfoot<sup>®</sup> is custom designed and sewn to fit the components of your project.</p>
          // 								</div>
          // 							`,
          //         image: "/images/fab-form-presewn-corners.webp",
          //       },
          //       {
          //         title: `Fastfoot<sup>®</sup> Monopour Library`,
          //         body: `
          // 								<div>
          // 									<h3>Footing Detail</h3>
          // 									<ol>
          // 										<li><a href="/docs/fab-form-footing-detail.pdf" onclick="window.open(this.href,'_blank');return false;">PDF file</a></li>
          // 										<li><a href="/docs/fab-form-footing-detail.DWG" onclick="window.open(this.href,'_blank');return false;">DWG file</a></li>
          // 									</ol>
          // 									<h3>Stem Wall</h3>
          // 									<ol>
          // 										<li><a href="/docs/fab-form-mp-stem-wall.pdf" onclick="window.open(this.href,'_blank');return false;">PDF file</a></li>
          // 										<li><a href="/docs/fab-form-mp-stem-wall.DWG" onclick="window.open(this.href,'_blank');return false;">DWG file</a></li>
          // 									</ol>
          // 									<h3>Full Basement</h3>
          // 									<ol>
          // 										<li><a href="/docs/fab-form-mp-full-basement.pdf" onclick="window.open(this.href,'_blank');return false;">PDF file</a></li>
          // 										<li><a href="/docs/fab-form-mp-full-basement.DWG" onclick="window.open(this.href,'_blank');return false;">DWG file</a></li>
          // 									</ol>
          // 									<h3>CSI Section Format</h3>
          // 									<ol>
          // 										<li><a href="/docs/fab-form-prefab-monopour-csi.pdf" onclick="window.open(this.href,'_blank');return false;">PDF file</a></li>
          // 										<li><a href="/docs/fab-form-prefab-monopour-csi-specifications.doc" onclick="window.open(this.href,'_blank');return false;">WORD
          // 										file</a> (right click to save)</li>
          // 									</ol>
          // 									<div class="clear"></div>
          // 									<h3>Marketing Materials</h3>
          // 									<ol>
          // 										<li><a href="/docs/fab-form-monopour-brochure.pdf" onclick="window.open(this.href,'_blank');return false;">ICF Monopour Brochure</a></li>
          // 									</ol>
          // 								</div>
          // 							`,
          //         image: "",
          //       },
          //     ],
          //   },
        ],
      },
      {
        id: "mphd",
        menuItem: {
          en: {
            title: "MPHD",
            menu: "MPHD",
          },
        },
        content: [
          {
            id: "overview",
            category: "monopour",
            menuItem: {
              en: {
                title: "MPHD Overview",
                menu: "Overview",
                url: urls.monopour.mphd.overview,
                metaTitle: "MPHD Overview - Heavy Duty Monopour System",
                metaDescription: "The MPHD Monopour System is a heavy-duty footing bracket designed for ICF blocks with molded ties. Perfect for contractors, the MPHD features rapid height adjustment, reusability, and fast installation for efficient foundation construction.",
              },
            },
            body: ``,
            images: [],
            videos: [],
            articles: [
              {
                title: "",
                body: `
										<div>
											<p>The Monopour HD is a footing bracket designed to work with all ICF blocks where the ties are molded into the EPS. It should not be used with ties that are slid into the foam panels. The brackets are re-usable and so are ideal for contractors that do multiple ICF foundations each year.</p>
											<p>Features:</p>
											<ul class="disc-list">
												<li>Faster: Save up to a week by eliminating the</li>
												<li>Acme threads for long life</li>
												<li>Reverse thread to enable the removal of the driver for lubrication</li>
												<li>Height adjustment from 0” to 14”</li>
												<li>Rapid adjustment with electric drill</li>
												<li>Packaging: 6 MPHDs per Mid Zote</li>
												<li>Weight: 7.5 pounds each, 15 pounds per pair</li>
												<li>Hex driver provided with each Mid Zote</li>
											</ul>
										</div>
									`,
                image: "/images/monopour-hd-brochure.webp",
              },
            ],
          },
          {
            id: "installation",
            category: "monopour",
            menuItem: {
              en: {
                title: "MPHD Installation",
                menu: "Installation",
                url: urls.monopour.mphd.installation,
                metaTitle: "MPHD Installation - Step-by-Step Guide for Heavy Duty Monopour System",
                metaDescription: "Follow our comprehensive guide for installing the MPHD (Monopour Heavy Duty) system. This step-by-step process will help you install and adjust the system for accurate and efficient footing construction with ICF blocks.",
              },
            },
            body: ``,
            images: [],
            videos: [
				{
					video: "https://www.youtube.com/embed/-LPxFFnsMlw?si=Xkoq6Xq-6ZbLut2H?autoplay=1",
					title: "Monopour HD Installation",
				}
			],
            articles: [
              {
                title: "1. Excavation",
                body: `<div class="text-start">To save time later on in the construction process, having a level excavation +-2" is ideal for the system. This will reduce time spent onsite adjusting attachment of Fastfoot later on.</div>`,
                image: "",
              },
              {
                title: "2. Stringlines and batter boards",
                body: `<div class="text-start">Setup batter boards and stringlines around perimeter with string located exactly 8" outside ICF and about 4" above top of footing. Loop end of string so it can be quickly taken down when not needed.</div>`,
                image: "/images/mphd-installation-step-2.webp",
              },
              {
                title: "3. Spray paint Layouts",
                body: `<div class="text-start">Using stringline as guide, spray paint centerline of footing, and with another colour, spray paint outside of ICF wall.</div>`,
                image: "/images/mphd-installation-step-3.webp",
              },
              {
                title: "4. Layout Fastfoot",
                body: `
										<div>
											<p>Place Fastfoot corners and t-junctions in posisition. Then unroll Fastfoot with 12" overlap with corners/tee’s.</p>
											<p>Either tape the overlaps, or place a negative/positive overlap. Ensuring you pour with these overlaps to prevent concrete leakage.</p>
										</div>
									`,
                image: "/images/mphd-installation-step-4.webp",
              },
              {
                title: "5. Build ICF Wall",
                body: `
										<div>
											<p>Starting at corners, build your ICF wall on top of the Fastfoot as you normally would on top of a footing.</p>
											<p>When approaching a common stack joint (marriage line) ensure at least a 1" gap, which will be fine tuned later.</p>
											<p>Install rebar and install second course of ICF. Ensure corner and straight rebar is NOT tied at this point.</p>
											<p>Tying rebar together will make it difficult to adjust wall lengths later on.</p>
										</div>
									`,
                image: "/images/mphd-installation-step-5.webp",
              },
              {
                title: "6. Install MPHD",
                body: `<div>Beginning at corner, install a pair of MPHD to the inside and outside face of the corner, using three screws per MPHD. Then place a pair 6’ on center around the perimeter of the foundation. Move Fastfoot to suit.</div>`,
                image: "/images/mphd-installation-step-6.webp",
              },
              {
                title: "7. Rough adjustment",
                body: `<div>Using a laser and 2’ level, begin drilling the ICF wall to required height. Ensure corners are plumb and kept in the correct position against your spray-painted line.</div>`,
                image: "/images/mphd-installation-step-7.webp",
              },
              {
                title: "8. Lock in wall dimensions",
                body: `<div>Using a tape, your stringlines, and the 3-4-5 method, confirm wall lengths and corner positions. Strap vertical stack joints with 1x4 ensuring both sides match with a laser.</div>`,
                image: "/images/mphd-installation-step-8.webp",
              },
              {
                title: "9. Install footing rebar",
                body: `<div>Ensure the Fastfoot centerline is in the middle of the ICF wall. Install footing rebar with chairs as per local code. Weight of the rebar will ensure Fastfoot doesn’t shift and the centerline stays in position throughout the build.</div>`,
                image: "/images/mphd-installation-step-9.webp",
              },
              {
                title: "10. Attach Fastfoot",
                body: `
										<div>
											<p>Confirm in multiple locations the depth of your current footing. Using this information use the calculator on to establish your “fold distance”.</p>
											<p>Using a plywood wood batten and #8 1-1/2” wood deck screws, fold Fastfoot over the batten and begin at corners screwing into each web of the ICF. Maintaining 12” overlaps on corner material.</p>
										</div>
									`,
                image: "/images/mphd-installation-step-10.webp",
              },
              {
                title: "11. Continue building wall",
                body: `<div>Continue building the ICF wall until a height of roughly 6’ is reached. If necessary, make slight adjustments to wall height with MPHD.</div>`,
                image: "/images/mphd-installation-step-11.webp",
              },
              {
                title: "12. Install Zont Bracing",
                body: `<div>Beginning 12" from an inside corner install a pair of Zont brackets, one at the top of the ICF wall and one at the bottom of the second course of ICF. Place walers and strongbacks in position.</div>`,
                image: "/images/mphd-installation-step-12.webp",
              },
              {
                title: "13. Stake wall in position",
                body: `<div>Drive a stake adjacent to each strong back, and move wall back and forth until it is exactly 8" off of stringline, then screw to strongback. Install Zuckle to one end of a suitably sized 2x4” and attach to where the top of wall will be in the future. Ensure Zuckle is at mid range on adjustment and that the lumber is facing upwards to ensure maximum travel. Double stake lumber end of kicker into ground. With an electric drill ensure wall is plumb.</div>`,
                image: "/images/mphd-installation-step-13.webp",
              },
              {
                title: "14. Final height adjustment",
                body: `<div>Check top of wall heights with a lazer. IF adjustment of wall is necessary, back off Zont Camlocks to all wall height adjustment. If you do not release the Zonts from the strongback you are asking your drill and the MPHD to lift your stakes and ICF wall out of the ground.</div>`,
                image: "/images/mphd-installation-step-14.webp",
              },
              {
                title: "15. Complete building ICF wall",
                body: `<div>Continue constructing your ICF wall as per manufacturer instruction. If needed install Zat walkway bracket roughly 3’ from top of wall for safe concrete placement. Once final wall height is achieved, installfinal Zont brackets at top of wall using a 6” extension. Installfinal horizontal walers. Set up stringlines at top of wall and adjust Zuckles to ensure the wall is straight.</div>`,
                image: "/images/mphd-installation-step-15.webp",
              },
              {
                title: "16. Concrete Pour",
                body: `
										<div>
											<p>Order Concrete with a 5-6" slump, concrete should freely floow into footing. Pour the footing + 6" of the first block. Allow sfficient time for the footing concrete to “go off”. Depending on the size of the project, an accelerator may be required.</p>
											<p>Note that winter pours will greatly increase cure time, as the cold soil will slow the chemical reaction.</p>
											<p>Continue with lifts of concrete as you would with a conventional ICF pour.</p>
										</div>
									`,
                image: "",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "zont-bracing",
    menuItem: {
      en: {
        title: "Zont Bracing",
        menu: "Zont Bracing",
        underTitle: "ICF Bracing Systems",
        shortDescription: `<a class="product-link" href="/${lang}/${urls.zontBracing.overview}">Zont Bracing</a> is a reusable bracing system designed to support ICF walls and tilt-up concrete walls during construction. It holds the walls plumb and straight while the concrete is being poured and cured.`,
      },
    },
    image: "/images/icf-zont.webp",

    isProduct: true,
    content: [
      {
        id: "overview",
        category: "zont-bracing",
        menuItem: {
          en: {
            title: "Zont Bracing Overview",
            menu: "Overview",
            url: urls.zontBracing.overview,
            metaTitle: "Zont Bracing Overview - ICF Bracing Systems for Straight and Plumb Walls",
            metaDescription: "Zont Bracing is a reusable ICF bracing system designed to support ICF walls during construction. It ensures walls stay plumb and straight while concrete is poured and cured. Learn how Zont Bracing provides an economical and efficient solution for wall alignment.",
          },
        },
        images: [],
        videos: [
          {
            video: "https://www.youtube.com/embed/r36rGfmI9bQ?autoplay=1",
            title: "Zont™ Insulated Concrete Form (ICF) Bracing",
            splashScreen:
              "/images/zont-insulated-concrete-form-icf-bracing-youtube.webp",
          },
        ],
        articles: [
          {
            title: "Straighter Walls",
            body: `<div><p>HoriZONTal walers are the first contact with the wall, straightening first in the 
								horizontal direction.</p>
								<p>Compare this with conventional vertical braces where the first contact is vertical, 
								leading to a wavy horizontal alignment.</p></div>`,
            image: "/images/zont-bracing-straighter-walls.webp",
          },
          {
            title: "Economic",
            body: `<div><p>Zont™ bracing is approximately 10% the cost of vertical bracing.</p>
								<p>Why rent conventional braces when you can buy for the same price?</p></div>`,
            image: "/images/zont-bracing-economic.webp",
          },
          {
            title: "Fast to Install",
            body: `<p>A "twist" of the wrist quickly locks the horizontal waler and vertical strongback in position.</p>`,
            image: "/images/zont-bracing-fast-to-install.webp",
          },
          {
            title: "Light Weight",
            body: `<p>Zont™ waler brackets and Zuckle™ wall aligners weight 11% the weight of conventional vertical bracing.</p>`,
            image: "/images/zont-bracing-light-weight.webp",
          },
          {
            title: "Height Adaptable",
            body: `<div><p>Brace short stem walls or 20' tall walls.</p>
								<p>Just add another row of Zonts™ and walers for every five feet of wall.</p></div>`,
            image: "/images/zont-bracing-height-adaptable.webp",
          },
          {
            title: "Easy Bucking",
            body: `<p>Window and end of wall bucks are easily reinforced as there are no vertical braces in the way.</p>`,
            image: "/images/zont-bracing-easy-bucking.webp",
          },
          {
            title: "Easy to Transport",
            body: `<div><p>Zont galvanized totes easily carry 20 Zonts or 15 Zuckles. The Zotes are stackable 
								and have drainage holes to prevent filling with water. <a href="/${lang}/${urls.zontBracing.components.zote}">Click 
								here for more information.</a></p></div>`,
            image: "/images/zont-bracing-zote.webp",
          },
          {
            title: "Green",
            body: `<p>Use site available 2x4s, save on delivery and storage costs.</p>`,
            image: "/images/zont-bracing-green.webp",
          },
        ],
      },
      {
        id: "components",
        category: "zont-bracing",
        menuItem: {
          en: {
            title: "Components",
            menu: "Components",
          },
        },
        title: "Components",
        images: [],
        videos: [],
        content: [
          {
            id: "zont",
            category: "components",
            menuItem: {
              en: {
                title: "Zont Twist Bracket",
                menu: "Zont",
                url: urls.zontBracing.components.zont,
                metaTitle: "Zont Twist™ Bracket - Locking ICF Wall Bracing System",
                metaDescription: "The Zont Twist™ Bracket locks 2x4 walers and strongbacks against ICF walls for horizontal and vertical alignment. Featuring a twist cam for quick locking and a durable design, this bracket ensures efficient and reliable wall bracing.",
              },
            },
            body: ``,
            images: [],
            videos: [],
            articles: [
              {
                title: "Zont Twist™ Bracket",
                body: `<div><p>The Zont Twist™ locks the 2x4 walers and strongbacks against the
														ICF wall to flatten the wall horizontally and vertically.</p>
														<p>The plastic cam is twisted counterclockwise to quickly lock
														the lumber, reducing the installation time by one half. The cam is designed so that any wall settlement
														will tighten the lumber against the wall.</p>
														<h3>Specifications:</h3>
														<ul>
															<li>Galvanized to prevent corrosion</li>
															<li>Strong 10 gauge steel</li>
															<li>High strength polypropylene cam</li>
															<li>Unit weight: 1.86 pounds</li>
															<li>Packaging: 20 per box</li>
															<li>Box weight: 39 pounds</li>
															<li>Box size: 20.5&quot; x 11.5&quot; x 10.3&quot; H</li>
														</ul></div>`,
                image: "/images/zont-bracing-twist-with-labels.webp",
              },
              {
                title: "",
                body: `<p>Zonts are screwed to ICF webs using two #8 x 1-1/2" deck screws, then the
														horiZONTal walers set in place. There is never a need to use "formlock" with the
														Zont bracing system.</p>`,
                image: "/images/zont-bracing-project.webp",
              },
            ],
          },
          {
            id: "zuckle",
            category: "components",
            menuItem: {
              en: {
                title: "Zuckle",
                menu: "Zuckle",
                url: urls.zontBracing.components.zuckle,
                metaTitle: "Zuckle™ Wall Aligner - Fast and Lightweight ICF Bracing Tool",
                metaDescription: "The Zuckle™ Wall Aligner is a lightweight, easy-to-install tool designed for aligning ICF walls. It provides fast adjustment with an electric drill and is 40% lighter than traditional turnbuckles, making it ideal for ICF construction.",
              },
            },
            title: "Zuckle",
            images: [],
            videos: [],
            articles: [
              {
                title: "Zuckle™ Wall Aligner",
                body: `<div><p>Finally. A wall aligner specifically designed for ICF walls.
														Only 3.6 pounds, just half the weight of conventional
														turnbuckles. And fast adjustment with your electric drill.</p>
														<h3>Specifications:</h3>
														<ul>
															<li>Weight: only 3.6 pounds;</li>
															<li>Zinc plated to prevent corrosion;</li>
															<li>Acme thread for durability and self-cleaning of concrete;</li>
															<li>10 gauge sheet metal frame and end;</li>
															<li>Packaging: 10 per box</li>
															<li>Box weight: 39 pounds</li>
															<li>Box size: 20&quot; x 13&quot; x 6&quot;</li>
														</ul></div>`,
                image: "/images/zont-bracing-zuckle-with-lettering.webp",
              },
              {
                title: "Zuckle Maintenance",
                body: `
														<div>
															<p>With proper maintenance, your Zuckles will last a very long time. Every five uses,
															complete the following:</p>
															<ul>
																<li>At the washer end of the sleeve, place a few drops of oil and spin the
																attachment flange;</li>
																<li>Grease the acme threads using a tooth brush dipped in grease.</li>
															</ul>
														</div>
													`,
                image: "",
              },
              {
                title: "",
                body: `<p>The contractor nails the angled plate of the Zuckle to the footing to provide a solid base for his kicker.</p>`,
                image: "/images/zuckle-to-footing.webp",
              },
            ],
          },
          {
            id: "zat",
            category: "components",
            menuItem: {
              en: {
                title: "Zat",
                menu: "Zat",
                url: urls.zontBracing.components.zat,
                metaTitle: "Zat Catwalk Bracket - Quick and Collapsible ICF Bracing System",
                metaDescription: "The Zat Catwalk Bracket provides an efficient way to set up a catwalk for ICF wall construction. It collapses for easy transportation and ensures a safe working environment while providing full walkway space for contractors.",
              },
            },
            title: "Zat",
            images: [],
            videos: [],
            articles: [
              {
                title: "",
                body: `<p>The Zat easily folds down for shipment and storage.</p>`,
                image: "/images/zont-bracing-folding-zat.webp",
              },
              {
                title: "",
                body: `<p>Contractor attaches the Zuckle wall aligner to the bottom of the handrail post,
														making for easy wall alignment.</p>`,
                image: "/images/zont-bracing-attaching-zuckle.webp",
              },
              {
                title: "",
                body: `<p>The post holder on the Zat is pitched outwards. This gives a full 24" of space
														for the contractor and his tool belt.</p>`,
                image: "/images/zont-bracing-pitched-handrail.webp",
              },
              {
                title: "",
                body: `<p>Contractor Shawn McDaniel is pleased with the new Zat catwalk bracket.</p>`,
                image: "/images/zont-bracing-complete.webp",
              },
            ],
          },
          {
            id: "zote",
            category: "components",
            menuItem: {
              en: {
                title: "Zote",
                menu: "Zote",
                url: urls.zontBracing.components.zote,
                metaTitle: "Zote Storage System - Galvanized Steel Totes for Zont Bracing",
                metaDescription: "Zote is a durable galvanized steel tote system designed for storing Zont Bracing components. It prevents water accumulation and is available in two sizes for easy storage and transportation of ICF bracing parts.",
              },
            },
            images: [],
            videos: [],
            articles: [
              {
                title: "LO ZOTES & ZOTES",
                doc: "/docs/zont-bracing-loading-in-zote.pdf",
                body: `<div><p>Finally galvanized steel totes that are nearly indestructible.
														Replaces plastic totes that always crack and break. Available in two
														sizes: <span class="font-bold">Lo Zote</span> and <span class="font-bold">Zote</span>:</p>
														<ol>
															<li>Both sizes are inter-stackable</li>
															<li>Four drain holes to prevent water accumulation</li>
															<li>Solid steel handles for easy lifting</li>
															</ol>
														<ul>
															<li>Zinc plated to prevent corrosion</li>
														</ul>
														<h2 class="page_articleTitle">Lo Zote</h2>
														<ul>
															<li>Holds 10 <a href="/${lang}/${urls.zontBracing.components.zuckle}">Zuckles</a>
															or 18 pairs of <a href="/${lang}/${urls.zontBracing.components.zeveler}">Zevelors</a></li>
															<li>Size: 21.5&quot; x 13&quot; x 5-1/2&quot; x 21 gauge</li>
															<li>Weight: 7.7 pounds</li>
															<li>Exactly half the height of Zote for easy stacking on pallets with Zotes</li>
														</ul>
														<h2 class="page_articleTitle">Zote</h2>
														<ul>
															<li>Holds 20 <a href="/zont-bracing/components/zont">Zonts</a></li>
															<li>Size: 21.5&quot; x 13&quot; x 11&quot;</li>
															<li>Weight: 10.9 pounds</li>
														</ul></div>`,
                image: "/images/zont-bracing-zotes-in-warehouse.webp",
              },
              {
                title: "Packaging Zonts in Zotes",
                body: `<p>20 Zotes are easily packed in one Zote as per the drawing shown above.
														Click on image for a PDF for printing.</p>`,
                image: "/images/zont-bracing-loading-in-zote.webp",
              },
            ],
          },
          {
            id: "zee",
            category: "components",
            menuItem: {
              en: {
                title: "Zee",
                menu: "Zee",
                url: urls.zontBracing.components.zee,
                metaTitle: "Zee™ T-Bracket for ICF T-Junctions - Efficient and Space-Saving",
                metaDescription: "The Zee™ T-Bracket simplifies the formation of T-junctions for ICF walls, eliminating the need for bulky T-blocks and marriage lines. Learn how the Zee bracket improves efficiency and reduces labor costs in your construction project.",
              },
            },
            images: [],
            videos: [],
            articles: [
              {
                title: "ZEEs vs. T-Blocks",
                doc: "/docs/zont-brzcing-zee-vs-t-block.pdf",
                body: `<p>The Zee Bracket has many advantages over the T-Block as shown in the drawing
														below. For a printable PDF, click on the image.</p>`,
                image: "/images/zont-bracing-zee-vs-t-block.webp",
              },
              {
                title: "Installation",
                doc: "/docs/zont-bracing-zee-installation.pdf",
                body: `<p>ZEEs are easy to install as per the instructions below. For a printable PDF,
														click on the image.</p>`,
                image: "/images/zont-bracing-zee-installation.webp",
              },
              {
                title: "Use ZEEs to Strengthen Window Bracing",
                doc: "/docs/zont-bracing-zee-window-bracing.pdf",
                body: `<p>ZEEs are used to strengthen and ensure window bracing is at 90 degrees.
														For a printable PDF, click on the image.</p>`,
                image: "/images/zont-bracing-buck-fab-form.webp",
              },
              {
                title: "Lightweight, easy to install",
                doc: "",
                body: `<p>Each ZEE weighs just 2.9 pounds and is easy to install using 1-1/2" x #8
														deck screws. They work with all ICFs that have the ties molded into the foam.</p>`,
                image: "/images/zont-bracing-zee-top-view.webp",
              },
              {
                title: "Eliminate 3 marriage lines per T-junction",
                doc: "",
                body: `<p>Forming T-junctions with ZEEs eliminates three marriage lines at each junction.
														As each marriage line takes approximately 40 minutes to cut, reinforce with 1x4s and
														strip, that's a lot of wasted labour. In the photo below, no marriage lines were
														required using ZEEs.</p>`,
                image: "/images/zont-bracing-zee-jobsite.webp",
              },
              {
                title: "Reinforce Offset Corners",
                doc: "",
                body: `<p>Offset corners are always a challenge to brace. ZEEs allow you to do this
														quickly without having to rip down plywood and waste dimensional lumber. As ZEEs
														can be reused many times, their effective cost is minimal.</p>`,
                image: "/images/zont-bracing-reinforce-corners.webp",
              },
              {
                title: "Increase site storage",
                doc: "",
                body: `<p>ICF T-blocks are extremely bulky and take up a lot of site space.
														Eliminate T-blocks and save space with ZEEs.</p>`,
                image: "/images/zont-bracing-increase-site-storage.webp",
              },
              {
                title: "Reduce delivery costs",
                doc: "",
                body: `<p>By eliminating bulky T-blocks your delivery costs will be reduced significantly.</p>`,
                image: "/images/zont-bracing-reduce-delivery-costs.webp",
              },
              {
                title: "Free up valuable warehouse space",
                doc: "",
                body: `<div><p>ICF T-junctions take up too much warehouse space. Eliminate
														T-junctions and save space for faster moving products.</p>
														<h2 class="page_articleTitle">Reduce SKUs</h2>
														<p>Stocking 4", 6", 8" 10" and 12" T-junctions is problematic as they
														are very prone to damage. ZEEs eliminate the need for these SKUs.</p></div>`,
                image: "/images/zont-bracing-warehouse-space.webp",
              },
              {
                title: "Long lasting",
                doc: "",
                body: `<p>ZEEs are manufactured from high quality zinc plated steel and will withstand years of rental.</p>`,
                image: "/images/zont-bracing-zee.webp",
              },
            ],
          },
          {
            id: "zeveler",
            category: "components",
            menuItem: {
              en: {
                title: "Zeveler",
                menu: "Zeveler",
                url: urls.zontBracing.components.zeveler,
                metaTitle: "Zeveler™ ICF Leveling System - Fast and Accurate Wall Adjustment",
                metaDescription: "The Zeveler™ system is an effective solution for leveling ICF walls over uneven footings. With easy installation and adjustable height, Zevelers ensure a perfect wall alignment and provide a cost-effective method to level your ICF walls.",
              },
            },
            images: [],
            videos: [],
            articles: [
              {
                title: "Fast and Effective Leveling of ICF Walls",
                doc: "",
                body: `<div>
															<p>Footings out of level? Zevelers are an accurate and time saving method to
															level your ICF wall over an out of level footing. Click on the first video to see more.</p>
															<h2 class="page_articleTitle">Project in Vancouver BC</h2>
															<p>This crew makes short work of levelling the ICF blocks using Zevelers, even with step
															footings. So much faster than using wooden wedges and cutting the bottom or your ICF blocks.
															Click on the second video to see more.</p>
														</div>
													`,
                image: "",
              },
              {
                title: "Zeveler Bracket",
                body: `<div><p>The Zeveler bracket is ideal for leveling up the ICF wall on top of a
														footing that is out of level.</p>
														<p>Pairs of Zevelers are installed 8' on center around the perimeter
														of the bottom two levels of ICF blocks and adjusted to level the
														wall perfectly. The space between the bottom of the ICF wall and the
														footing is then filled in with ICF non-expansive foam.</p>
														<p>The 6mm driver has a socket head which allows it to pivot as the
														driver turns. This allows easy adjustment with an electric drill.</p>
														<p>The bottom of the Zeveler has a high strength PE head which provides
														a point contact with the concrete footing. This prevents the base of the
														threaded rod from 'walking' on the footing.</p>
														<p>It’s best to store in our ‘Lo Zote’ — <a href="/${lang}/${urls.zontBracing.components.zote}">learn more here</a>.</p>
														for more information. Find our discounted price on the Lo Zote with
														18 Zevelers.</p>
														<h3>Specifications:</h3>
														<ul class="disc-list">
															<li>Galvanized to prevent corrosion</li>
															<li>Strong 12 gauge steel frame</li>
															<li>1/2" ready rod for the adjuster</li>
															<li>Base of ready rod has plastic cone which prevents walking on
															concrete footing</li>
															<li>High quality, can be reused many times</li>
															<li>Unit weight: 1.0 pound</li>
															<li>Packaging: 18 pairs per box, including two 6mm drivers</li>
															<li>Box weight: 37 pounds</li>
															<li>Box size: 20.5&quot; x 11.5&quot; x 5&quot; H</li>
														</ul></div>`,
                image: "/images/zont-bracing-zeveler.webp",
              },
              {
                title: "",
                doc: "",
                body: `<p>Zevelers are screwed to ICF webs using two #8 x 1-1/2" deck screws. Longer
														screws will not work as the thread does not extend sufficiently.</p>`,
                image: "/images/zont-bracing-zeveler-1.webp",
              },
              {
                title: "",
                doc: "",
                body: `<p>A laser is used to adjust the wall to ensure that it is 100% level.</p>`,
                image: "/images/zont-bracing-zeveler-2.webp",
              },
              {
                title: "",
                doc: "",
                body: `<p>Non expansive foam glue is used to spot attach the bottom of the block to the
														footing. It is important to spot glue to prevent the foam from lifting the wall.</p>`,
                image: "/images/zont-bracing-zeveler-3.webp",
              },
              {
                title: "",
                doc: "",
                body: `<p>Once the spot glue has cured (about two hours), the space between the footing
														and wall is glued with a continuous bead of foam as shown in the photo above.</p>`,
                image: "/images/zont-bracing-zeveler-4.webp",
              },
              {
                title: "Installation",
                doc: "",
                body: `<p>Zevelers are easy to install as per the instructions below. For a printable PDF, <a href="/docs/zeveler-Installation.pdf">click here to download the PDF</a>.</p>`,
                image: "",
              },
            ],
          },
        ],
      },
      {
        id: "installation",
        category: "zont-bracing",
        menuItem: {
          en: {
            title: "Zont Bracing Installation",
            menu: "Installation",
            url: urls.zontBracing.installation,
            metaTitle: "Zont Bracing Installation Guide - Step-by-Step ICF Wall Bracing",
            metaDescription: "Learn how to install the Zont Bracing system for ICF walls with our step-by-step installation guide. Ensure accurate alignment and efficient bracing for your ICF construction project using Zont Bracing components.",
          },
        },
        images: [],
        videos: [
          {
            video: "https://www.youtube.com/embed/TnCjBUvP0NY?autoplay=1",
            title: "Zont Insulated Concrete Forms (ICF) Bracing - Installation",
            splashScreen: "/images/zont-icf-bracing-installation-youtube.webp",
          },
        ],
        articles: [
          {
            title: "Installation on Pre-Poured Footings & Slabs",
            body: `<div><p>All bracing systems must align the wall and provide a walkway for building the top of 
								the wall and place the concrete. Most inspection agencies require a 20" wide walkway 
								(two 2x10s) and a guard rail when the catwalk height is greater than 6'.</p>
								<p>Click on each image for a printable PDF.</p></div>`,
            image: "",
          },
          {
            title: "",
            body: ``,
            doc: "/docs/zont-bracing-installation-guide-below.pdf",
            image: "/images/zont-bracing-installation-below-6.webp",
          },
          {
            title: "",
            body: ``,
            doc: "/docs/zont-bracing-installation-guide-above.pdf",
            image: "/images/zont-bracing-installation-above-6.webp",
          },
          {
            title: "",
            body: ``,
            doc: "/docs/zont-bracing-zee-installation.pdf",
            image: "/images/zont-bracing-zee-installation.webp",
          },
        ],
      },
      {
        id: "estimator",
        category: "zont-bracing",
        menuItem: {
          en: {
            title: "Zont Bracing Estimator",
            menu: "Estimator",
            url: urls.zontBracing.estimator,
            metaTitle: "Zont Bracing Estimator - Calculate Bracing Materials for ICF Walls",
            metaDescription: "Use our Zont Bracing Estimator to calculate the quantities of Zont Bracing materials needed for your ICF wall project. Get accurate material estimates based on your project specifications including Zonts, Zuckles, and more.",
          },
        },
        images: [],
        videos: [],
        articles: [
          {
            title: "",
            body: `
								<div>
									<div class="page_zontEstimator_wrapper">
										<form id="zontEstimator">
											<div class="calc_zb_wrapper">
												<div class="calc-zb-form">
													<div class="calc-form-first-column">
														<div class="calc-icon-wrapper"><i class="fa fa-calculator calc-icon" aria-hidden="true"></i></div>
														<div class="calc_ft_block">
															<div class="ff-inputs-wrapper">
																<div class="container text-center">
																	<div id="wallBaseField" class="calc_ft_line row">
																		<label class="calc_ft_label" for="wallBase" id="wallBaseLabel">Base of wall</label>
																		<select id="wallBase" class="calc-ft-input me-2">
																			<option>Choose</option>
																			<option value="0">Prepoured</option>
																			<option value="1">Monopour</option>
																		</select>
																	</div>
																	<div id="blockHeightField" class="calc_ft_line row">
																		<label class="calc_ft_label" for="blockHeight">Block height (in)</label>
																		<input type="number" name="blockHeight" class="calc-ft-input input-width me-2"/>
																	</div>
																	<div id="walerLengthField" class="calc_ft_line row">
																		<label class="calc_ft_label" for="walerLength">Waler length (ft)</label>
																		<input type="number" name="walerLength" class="calc-ft-input input-width me-2"/>
																	</div>
																	<div id="wallHeightField" class="calc_ft_line row">
																		<label class="calc_ft_label" for="wallHeight">Wall height (ft)</label>
																		<input type="number" name="wallHeight" id="wallHeight-1" class="calc-ft-input input-width me-2"/>
																	</div>
																	<div id="perimeterField" class="calc_ft_line row">
																		<label class="calc_ft_label" for="perimeter">Perimeter (ft)</label>
																		<input type="number" name="perimeter" id="perimeter-1" class="calc-ft-input input-width me-2"/>
																	</div>
																	<div id="cornersField" class="calc_ft_line row">
																		<label class="calc_ft_label" for="corners">Corners</label>
																		<input type="number" name="corners" id="corners-1" class="calc-ft-input input-width me-2"/>
																	</div>
																	<div id="teesField" class="calc_ft_line row">
																		<label class="calc_ft_label" for="tees">Tees</label>
																		<input type="number" name="tees" id="tees-1" class="calc-ft-input input-width me-2"/>
																	</div>
																</div>
															</div>
														</div>
													</div>
													<div class="calc_ft_buttons">
														<input type="button" value="Add Height" id="addHeight" class="ft-button"/>
														<input type="button" value="Calculate" id="zontBracing_button" class="ft-button">
														<input type="reset" value="Reset" id="reset" class="ft-button"/>
													</div>
												</div>
													<div class="zb-calc-result">
														<div class="zont-table">
															<table>
																<tbody>
																	<tr>
																		<td class="result_ft_label"><a href="/${lang}/${urls.zontBracing.components.zont}">Zonts</a></td>
																		<td class="zont-result-cell" id="zonts"></td>
																	</tr>
																	<tr>
																		<td class="result_ft_label"><a href="/${lang}/${urls.zontBracing.components.zote}">Zotes</a></td>
																		<td class="zont-result-cell" id="zotes"></td>
																	</tr>
																	<tr>
																		<td class="result_ft_label"><a href="/${lang}/${urls.zontBracing.components.zuckle}">Zuckle</a></td>
																		<td class="zont-result-cell" id="zuckles"></td>
																	</tr>
																	<tr>
																		<td class="result_ft_label"><a href="/${lang}/${urls.zontBracing.components.zote}">Lo Zote</a></td>
																		<td class="zont-result-cell" id="loZotes"></td>
																	</tr>
																	<tr>
																		<td class="result_ft_label"><a href="/${lang}/${urls.zontBracing.components.zat}">Zats</a></td>
																		<td class="zont-result-cell" id="zats"></td>
																	</tr>
																	<tr>
																		<td class="result_ft_label"><a href="/${lang}/${urls.zontBracing.components.zee}">Zees</a></td>
																		<td class="zont-result-cell" id="zees"></td>
																	</tr>
																	<tr>
																		<td class="result_ft_label"><a href="/${lang}/${urls.zontBracing.components.zeveler}">Zeveler pairs</a></td>
																		<td class="zont-result-cell" id="zevelers"></td>
																	</tr>
																	<tr>
																		<td class="result_ft_label"><a href="/${lang}/${urls.zontBracing.overview}">Walers</a></td>
																		<td class="zont-result-cell" id="walers"></td>
																	</tr>
																</tbody>
															</table>
														</div>
														<div>
															<table>
																<thead>
																	<tr id="headerResultRow">
																		<th class="result_ft_label">Lumber</th>
																		<th class="result_ft_label">#1</th>
																	</tr>
																</thead>
																<tbody>
																	<tr id="strongbacksQtyResultRow">
																		<td class="result_ft_label">Strongbacks</td>
																		<td id="strongbacksQty-1"></td>
																	</tr>
																	<tr id="strongbackLgthResultRow">
																		<td class="result_ft_label">Strongback (ft)</td>
																		<td id="strongbackLgth-1"></td>
																	</tr>
																	<tr id="kickersQtyResultRow">
																		<td class="result_ft_label">Kickers (qty)</td>
																		<td id="kickersQty-1"></td>
																	</tr>
																	<tr id="kickersLgthResultRow">
																		<td class="result_ft_label">Kickers (ft)</td>
																		<td id="kickerLgth-1"></td>
																	</tr>
																</tbody>
															</table>
														</div>
													</div>
											</div>
										</form>
									</div>
									<p>This estimator calculates the quantities of bracing materials for either:</p>
									<ul class="disc-list">
										<li>Pre-poured footing or slab, or</li>
										<li>Fastfoot<sup>®</sup> Monopour</li>
									</ul>
									<p>Zont™ waler brackets are spaced approximately 6' on center horizontally, with waler layers 
									spaced vertically a maximum of 5' apart. Extra Zonts™ are required for each corner. The length 
									of 2x4 walers is chosen by you, with a 15% allowance for overlaps. The 2x4 strongback and 
									kicker lengths and quantities are determined automatically. The calculator allows for up to 
									three different wall heights.</p>
									<p>The calculator rounds up Zonts to box (Zote) quantities (20) and Zuckles 
									to box (Lo Zote) quantities (10).</p>
								</div>`,
            image: "",
          },
        ],
      },
      {
        id: "projects",
        menuItem: {
          en: {
            title: "Zont Bracing Projects",
            menu: "Projects",
            url: urls.zontBracing.projects,
            metaTitle: "Zont Bracing Projects - Successful ICF Bracing Implementations",
            metaDescription: "Explore the successful implementation of Zont™ bracing systems in various ICF construction projects. See how Zont Bracing enhances efficiency, cost-effectiveness, and precision in ICF wall construction.",
          },
        },
        category: "zont-bracing",
        images: [],
        videos: [],
        articles: [],
      },
      {
        id: "specifications",
        category: "zont-bracing",
        menuItem: {
          en: {
            title: "Zont Bracing Specifications",
            menu: "Specifications",
            url: urls.zontBracing.specifications,
            metaTitle: "Zont Bracing Specifications - Detailed Product Information",
            metaDescription: "Get detailed specifications for Zont Bracing components including the Zont Twist™ Bracket, Zuckle Wall Aligner, Zat Catwalk Bracket, and more. Learn about the materials, sizes, and features of each Zont Bracing part.",
          },
        },
        images: [],
        videos: [],
        articles: [
          {
            title: "Zont Twist™ Bracket",
            body: `<div><p>The Zont Twist™ locks the 2x4 walers and strongbacks against the 
								ICF wall to flatten the wall horizontally and vertically.</p>
								<p>The plastic cam is twisted counterclockwise to quickly lock 
								the lumber, reducing the installation time by one half. The cam is designed so that any wall settlement 
								will tighten the lumber against the wall.</p>
								<h3>Specifications:</h3>
								<ul class="disc-list">
									<li>Galvanized to prevent corrosion</li>
									<li>Strong 10 gauge steel</li>
									<li>High strength polypropylene cam</li>
									<li>Unit weight: 1.86 pounds</li>
									<li>Packaging: 20 per box</li>
									<li>Box weight: 40 pounds</li>
									<li>Box size: 20&quot; x 12&quot; x 10&quot; H</li>
								</ul></div>`,
            image: "/images/zont-bracing-twist-with-labels.webp",
          },
          {
            title: "Zuckle™ Wall Aligner",
            body: `<div><p>Finally. A wall aligner specifically designed for ICF walls. 40% 
								lighter than conventional turnbuckles. Rapid adjustment with an 
								electric drill and 10mm driver (one driver included per box). 10 
								gauge thickness steel plate galvanized for long life.</p>
								<h3>Specifications:</h3>
								<ul class="disc-list">
									<li>Weight: 3.6 pounds</li>             
									<li>Packaging: 10 per box</li>
									<li>One 10mm driver / box</li>
									<li>Box weight: 37 pounds</li>
									<li>Box size: 16&quot; x 9&quot; x 6&quot;</li>
								</ul></div>`,
            image: "/images/zont-bracing-zuckle-with-lettering.webp",
          },
          {
            title: "ZAT Catwalk Bracket",
            body: `<div><p>The ZAT bracket is the quickest way to provide a catwalk for your 
								foundation. ZAT collapses for easy transportation. Click on image 
								for more information.</p>
								<h3>Specifications:</h3>
								<ul class="disc-list">
									<li>Galvanized to prevent corrosion</li>
									<li>Strong 10 gauge (2.5 mm) steel</li>
									<li>Unit weight: 7.4 pounds</li>
									<li>Folded size (pair): 41.5&quot; x 5&quot; x 5.5"</li>
									<li>Under testing for OSHA Compliance</li>
									<li>Angled post support supplies a full 24" of walkway space at 
									hip height</li>
								</ul></div>`,
            image: "/images/zont-bracing-zat-650.webp",
          },
          {
            title: "ZEE T-bracket",
            body: `
								<div>
									<p>The ZEE bracket revolutionizes the way you build T-junctions. No need to purchase bulky 
									T-blocks. Quickly make your own T-junctions on site using standard blocks and ZEE brackets. 
									And eliminate <span class="font-bold">two</span> marriage lines at each T-junction.</p>
									<p>ZEEs <span class="auto-style1">eliminate</span> the cost of storing and shipping bulky 
									T-blocks. Click on image for more information.</p>
									<h3>Specifications:</h3>
									<ul class="disc-list">
										<li>Galvanized to prevent corrosion</li>
										<li>Strong 12 gauge (2 mm) steel</li>
										<li>Unit weight: 2.9 lbs.</li>
										<li>Size: 15" x 15" x 2-1/8"</li>
										<li>14 ZEEs per box, box weight 42.5 lbs., box size 16" x 16" x 
										3-1/4"</li>
									</ul>
								</div>
							`,
            image: "/images/zont-bracing-zee.webp",
          },
          {
            title: "ZOTE Totes",
            body: `
								<div>
									<p>Plastic totes for Zonts and Zuckles always crack and break. Finally. A galvanized 
									steel tote that is almost indestructible.</p>			
									<ul>
										<li>Galvanized&nbsp; 1mm thick steel for long life</li>
										<li>Both sizes are inter-stackable</li>
										<li>Four drain holes to prevent water accumulation</li>
										<li>Solid steel handles for easy lifting</li>
									</ul>
									<p>Available in two sizes:</p>
									<h2 class="page_articleTitle">Lo Zote</h2>
									<ul>
										<li>Holds 10 Zuckles</li>
										<li>Size: 21.5&quot; x 13&quot; x 5-1/2&quot;</li>
										<li>Weight: 7.7 pounds</li>
										<li>Exactly half the height of Zote for easy stacking on pallets</li>
									</ul>
									<h2 class="page_articleTitle">Zote</h2>
									<ul>
										<li>Holds 20 Zonts</li>
										<li>Size: 21.5&quot; x 13&quot; x 11&quot;</li>
										<li>Weight: 10.9 pounds</li>
									</ul>
								</div>
							`,
            image: "/images/zont-bracing-zote.webp",
          },
          {
            title: "Zont Brochures",
            doc: "/docs/zont-brochure.pdf",
            body: `<p>Click on the image for a PDF of the Zont™ Bracing tri-fold brochure, full colour, 
								printed both sides, with a folded size of 4-1/4" x 9".</p>`,
            image: "/images/zont-bracing-brochure-2019.webp",
          },
        ],
      },
    ],
  },
  {
    id: "space-r",
    menuItem: {
      en: {
        title: "Space-R",
        menu: "Space-R",
        url: "space-r",
        underTitle: "Rebar Support System",
        shortDescription: `<a class="product-link" href="/${lang}/${urls.spacer.overview}">SPACE-R™</a> is a patented reinforcement support system for concrete columns that holds vertical rebar in the correct position while ensuring proper concrete cover around the rebar.`,
      },
    },
    image: "/images/space-r.webp",
    isProduct: true,
    content: [
      {
        id: "overview",
        category: "space-r",
        menuItem: {
          en: {
            title: "Space-R Overview",
            menu: "Overview",
            url: urls.spacer.overview,
            metaTitle: "Space-R Overview - Accurate Rebar Placement in Column Forms",
            metaDescription: "Space-R™ ensures precise rebar placement in column forms, offering high-strength continuous glass fiber stirrups, guaranteed concrete cover, and perfect vertical bar spacing. Compatible with all column forms, fabric or rigid.",
          },
        },
        images: [],
        videos: [],
        articles: [
			{
				en: {
				  body: ``,
				  image: "/images/space-r-prototype.webp",
				},
			  },
          {
            en: {
              body: `
									<div>
										<p>Accurately <span class="font-yellow">SPACE-R</span>ebar in column forms</p>
										<ul class="disc-list">
											<li>High strength, continuous glass fiber stirrup.</li>
											<li>Guaranteed 1.5" (40mm) concrete cover.</li>
											<li>Vertical bars spaced perfectly around circumference.</li>
											<li>Integrated zipties hold vertical rebars solidly in position.</li>
											<li>Works with all column forms, fabric or rigid.</li>
										</ul>
									</div>
								`,
								image: "/images/space-r-proto.webp",
            },
          },
          {
            en: {
              body: `
									<div class="table-wrapper">
										<div class="container packaging mr-20">
											<div class="row row_underline align-items-center">
												<div class="col text-center">Column Diameter</div>
											</div>
											<div class="row row_underline align-items-center">
												<div class="col text-center">in</div>
												<div class="col text-center">mm</div>
												<div class="col text-center"># Verts</div>
											</div>
											<div class="row row_underline align-items-center">
												<div class="col text-center">8</div>
												<div class="col text-center">200</div>
												<div class="col text-center">4</div>
											</div>										
											<div class="row row_underline align-items-center">
												<div class="col text-center">10</div>
												<div class="col text-center">250</div>
												<div class="col text-center">4</div>
											</div>
											<div class="row row_underline align-items-center">
												<div class="col text-center">12</div>
												<div class="col text-center">300</div>
												<div class="col text-center">4</div>
											</div>
											<div class="row row_underline align-items-center">
												<div class="col text-center">14</div>
												<div class="col text-center">350</div>
												<div class="col text-center">6</div>
											</div>
											<div class="row row_underline align-items-center">
												<div class="col text-center">16</div>
												<div class="col text-center">400</div>
												<div class="col text-center">6</div>
											</div>
											<div class="row row_underline align-items-center">
												<div class="col text-center">18</div>
												<div class="col text-center">450</div>
												<div class="col text-center">6</div>
											</div>
											<div class="row row_underline align-items-center">
												<div class="col text-center">20</div>
												<div class="col text-center">500</div>
												<div class="col text-center">8</div>
											</div>
											<div class="row row_underline align-items-center">
												<div class="col text-center">22</div>
												<div class="col text-center">550</div>
												<div class="col text-center">8</div>
											</div>
											<div class="row row_underline align-items-center">
												<div class="col text-center">24</div>
												<div class="col text-center">600</div>
												<div class="col text-center">8</div>
											</div>
										</div>
										<div class="table-wrapper flex-wrap">
											<div class="container packaging mb-3">
												<div class="row row_underline align-items-center">
													<div class="col text-center">Stirrup Specifications</div>
												</div>
												<div class="row row_underline align-items-center">
													<div class="col text-center">Glass fiber stirrup</div>
													<div class="col text-center">inch</div>
													<div class="col text-center">mm</div>
												</div>
												<div class="row row_underline align-items-center">
													<div>Diameter</div><div>0.39</div><div>10.0</div>
												</div>
											</div>

											<div class="container packaging mb-3">
												<div class="row row_underline align-items-center">
													<div class="col text-center">Glass Fiber Strength</div>
												</div>
												<div class="row row_underline align-items-center">
													<div class="col text-center">Glass fiber</div>
													<div class="col text-center">psi</div>
													<div class="col text-center">MPa</div>
												</div>
												<div class="row row_underline align-items-center">
													<div class="col text-center">Tensile strength</div>
													<div class="col text-center">104,282</div>
													<div class="col text-center">719</div>
												</div>
												<div class="row row_underline align-items-center">
													<div class="col text-center">Shear strength</div>
													<div class="col text-center">34,664</div>
													<div class="col text-center">239</div>
												</div>
											</div>

											<div class="container packaging mb-3">
												<div class="row row_underline align-items-center">
													<div class="col text-center">10mm Dia. Stirrup Strength</div>
												</div>
												<div class="row row_underline align-items-center">
													<div class="col text-center">10mm dia. stirrup</div>
													<div class="col text-center">lb.</div>
													<div class="col text-center">kN</div>
												</div>
												<div class="row row_underline align-items-center">
													<div class="col text-center">Tensile capacity</div>
													<div class="col text-center">12,696</div>
													<div class="col text-center">56.5</div>
												</div>
												<div class="row row_underline align-items-center">
													<div class="col text-center">Shear capacity</div>
													<div class="col text-center">4,220</div>
													<div class="col text-center">18.8</div>
												</div>
											</div>
										</div>
									</div>
								`,
              image: "",
            },
          },
        ],
      },
    ],
  },
  {
    id: "level-r",
    menuItem: {
      en: {
        title: "Level-R",
        menu: "Level-R",
        underTitle: "Rail Support",
        shortDescription: `<a class="product-link" href="/${lang}/${urls.levelr.overview}">Level-R</a> is an adjustable form support system that ensures concrete footings and forms are set perfectly level during construction.`,
      },
    },
    image: "/images/level-r.webp",
    isProduct: true,
    content: [
      {
        id: "overview",
        category: "level-r",
        menuItem: {
          en: {
            title: "Level-R Overview",
            menu: "Overview",
            url: urls.levelr.overview,
            metaTitle: "Level-R Overview - Advanced Concrete Footing Support",
            metaDescription: "Level-R offers enhanced support for concrete footings. Explore its features and benefits for residential and commercial construction projects. Ensure a stronger, more reliable foundation with Level-R.",
          },
        },
        images: [],
        videos: [],
        articles: [
          {
            en: {
              image: "/images/level-r-installation-title.webp",
            },
          },
          {
            en: {
              title: "",
              body: `
								<div>
									<p>Level-R footing brackets enable the contractor to quickly adjust the height of his footing forming lumber using an electric drill. This enables easy and accurate height adjustment by one person, reducing labor cost significantly. Level-Rs are typically placed 12’ on center with conventional stakes driven between.</p>
									<p>Level-Rs are used with Fastfoot to aid in installation.</p>
									<p>Features:</p>
									<ul class="disc-list">
										<li>Zinc plating to prevent corrosion</li>
										<li>Acme threads for long life</li>
										<li>Reverse thread to enable the removal of the driver for lubrication</li>
										<li>Height adjustment from 0” to 11”, so with a 2x4 edge form, maximum footing height is 15”</li>
										<li>Rapid adjustment with electric drill</li>
										<li>Packaging: 8 Level-Rs per Mid Zote</li>
										<li>Weight: 5.0 pounds each, 10 pounds per pair.</li>
										<li>Hex driver provided in each Mid Zote.</li>
									</ul>
								</div>
								`,
              localVideo: "/videos/level-r",
            },
          },
        ],
      },
    ],
  },
  {
    id: "buy-now",
    menuItem: {
      en: {
        title: "Dealers map",
        menu: "Buy Now",
        url: "buy-now",
        metaTitle: "Fab-Form Dealers - Find a Fab-Form Dealer",
        metaDescription: "Interested in becoming a Fab-Form dealer? Fill out the dealer form and join our network. Learn more about our dealer requirements and benefits.",
      },
    },
    images: [],
    articles: [
      	{
        	en: {
         		title: "",
          		body: dealersForm().outerHTML,
        	},
      	},
      	{
        	title: "Payment methods:",
        	body: `<p>If the Buyer is located in the USA and if the transaction cost is greater than $2,000, the 
                    Buyer must supply a Federal Tax ID number to Fab-Form for the US Government.</p>`,
        	image: "/images/payment-methods.webp",
      	},
    ],
  },
  {
    id: "investor",
    menuItem: {
      en: {
        title: "Investor",
        menu: "Investor",
        url: "investor",
      },
    },
    content: [
      {
        id: "about",
        menuItem: {
          en: {
            title: "About Fab-Form",
            menu: "About",
            url: urls.investor.about,
            metaTitle: "About Fab-Form Industries - Mission, History, and Innovations",
            metaDescription: "Learn about Fab-Form Industries, a company dedicated to innovative construction solutions. Discover our mission, history, and product innovations, including Fastfoot® and Fast-Tube®.",
          },
        },
        images: ["/images/about-1.webp"],
        articles: [
          {
            title: "Mission Statement",
            body: `<div><p>Fab-Form Industries is dedicated to providing a rational and sustainable interface between the uneven 
							ground and manufactured components which make up the building structure.</p><p>Fab-Form is the only public 
							company that focuses solely on this interface. Our mandate is to continue to introduce innovative products 
							that increase earnings for our shareholders.</p></div>`,
            image: "",
          },
          {
            title: "History",
            body: `<div>
							<p>Fab-Form began in 1986 when the founder, Rick Fearn, was building a condominium project in 
								Vancouver, BC, and the forming contractor made a 2' error in the footing forms, wasting thousands 
								of dollars of 2x12 fir footing lumber. As Rick had his office located in a fabric warehouse, it 
								occurred to him that it should be possible to form the concrete using fabric. This was the start 
								of Fastfoot®, the fabric form to replace lumber.</p>
		
							<p>Innovation in the construction industry is very slow, especially with a paradigm change such as 
								fabric forming. Indeed, it took over 40 years for drywall to replace lath and plaster. In the 
								1980s, the only way to introduce innovation was by trade shows and setting up displays in local 
								lumber yards—all very slow and expensive. The World Wide Web was just beginning.</p>
		
							<p>By 1998, the founder had depleted his funds, and a stock market promoter promised $1 million by 
								going public. In 1999, Fab-Form Industries became public, trading under the symbol 
								<a rel="noreferrer" href=${urls.investor.tmxFbf} 
									onclick="window.open(this.href,'_blank');return false;" 
									title="Click here to go to TSX exchange">FBF</a>. 
								Sadly, the developer was only able to raise sufficient funds to pay the legal and brokerage costs, and left.</p>
		
							<p>Fab-Form survived by selling its core product, Fastfoot®. In 2003, Fab-Form developed the welding 
								and C-folding technology to manufacture an innovative Fast-Tube® column form. 
								<a href="/${lang}/${urls.fastTube.sunset}" title="Click here to see our first FT project">Henry Van Delft of Sunset Builders</a> 
								was the first user of Fast-Tube®. Contractors like Henry and his assistant Ron are crucial to the 
								development of innovative construction products.</p>
		
							<p>Fab-Form believes strongly in the public company structure as it enables our employees to become 
								owners. And it enables the public to participate in our growth as a result of innovative products 
								that assist in taming the ground (see below).</p>
							</div>
						`,
            image: "",
          },
          {
            title: "Innovations",
            body: `
							<ul>
								<li>1986 - <a href="/${lang}/${urls.fastFoot.residential.overview}">Fastfoot® fabric formwork</a> for footings (patented)</li>
								<li>1988 - <a href=${urls.fastFoot.residential.fastPad}>Fast-Pad</a>, fabric used to form footing pads (patented)</li>
								<li>1994 - <a href="/${lang}/${urls.fastFoot.residential.overview}">Fastfoot® manufacturing equipment</a>, to C-fold and produce rolls of Fastfoot®</li>
								<li>2000 - Fast-Yoke, metal brackets to support 2x4s and Fastfoot® (discontinued)</li>
								<li>2002 - <a href="/${lang}/${urls.fastTube.overview}">Fast-Tube® manufacturing equipment</a>, to C-fold and weld the fabric</li>
								<li>2003 - <a href="/${lang}/${urls.fastTube.overview}">Fast-Tube® column form</a>, for forming columns with fabric (patented)</li>
								<li>2008 - <a href="/${lang}/${urls.monopour.mpss.overview}">ICF Monopour</a>, for pouring the ICF wall and Fastfoot® footings at the same time (patented)</li>
								<li>2010 - <a href="/${lang}/${urls.zontBracing.overview}">Zont Bracing</a>, for ICFs (patented)</li>
								<li>2012 - <a href="/${lang}/${urls.zontBracing.components.zuckle}">Zuckle</a>, for aligning ICF walls</li>
								<li>2017 - <a href="/${lang}/${urls.zontBracing.components.zat}">Zat</a>, catwalk for ICF walls</li>
								<li>2018 - <a href="/${lang}/${urls.zontBracing.components.zee}">Zee</a>, for eliminating ICF T-blocks</li>
								<li>2018 - <a href="/${lang}/${urls.zontBracing.components.zeveler}">Zeveler</a>, for leveling up ICF walls on a prepoured footing</li>
								<li>2019 - <a href="/${lang}/${urls.zontBracing.components.zote}">ZOTE tote</a>, bin for transporting and storing Zonts and Zuckles</li>
								<li>2024 - <a href="/${lang}/${urls.levelr.overview}">Level-R</a>, bracket to quickly level footing forms (patent pending)</li>
								<li>2024 - <a href="/${lang}/${urls.monopour.mphd.overview}">Monopour HD</a>, bracket to quickly level ICF walls and monopour the footings at the same time (patent pending)</li>
								<li>2024 - <a href="/${lang}/${urls.spacer.overview}">SPACE-R</a>, replaces a column stirrup while holding the vertical rebar in position and providing spacing inside the column form (patent pending)</li>
							</ul>
						`,
            image: "/images/about-2.webp",
          },
          {
            title: "Share Structure",
            body: `
							<div>
								<p>Fab-Form Industries has a simple and transparent share structure. As of ${company.stocksDate}, 
									there are ${company.stocks} common shares issued.</p>
								<p>There are no preferred shares, no warrants, and no options outstanding. 
									Since 1999, the company has consistently made all required submissions to the Securities Commission 
									and the Stock Exchange.</p>
							</div>
						`,
            image: "/images/about-3.webp",
          },
          {
            title: "Share Price History",
            body: `
							<div>
								<p>Fab-Form common shares have increased from $0.05 to ${company.stockHigh}, 
									representing more than a forty-fold increase.</p>
								<p>While past share performance is no guarantee of future results, 
									<a href="/${lang}/${urls.investor.financials}">current earnings</a> reflect a continuation of healthy growth.</p>
								<p>View the <a href="/${lang}/${urls.investor.stockChart}" title="View current FBF share price">current FBF share price</a>.</p>
							</div>
						`,
            image: "/images/about-4.webp",
          },
        ],
      },
      {
        id: "stock-chart",
        menuItem: {
          en: {
            title: "Stock Chart",
            menu: "Stock Chart",
            url: urls.investor.stockChart,
            metaTitle: "Fab-Form Stock Chart - TSX Venture Symbol FBF",
            metaDescription: "View the current stock chart for Fab-Form Industries (FBF) on the Toronto Venture Exchange. Track historical performance and trends.",
          },
        },
        images: [],

        articles: [
          {
            title: "",
            body: `
              <div class="stock-chart-wrapper">
                <p>Fab-Form has ${company.stocks} shares issued on the Toronto Venture Exchange under the symbol
	                <a rel="noreferrer" href="https://web.tmxmoney.com/company.php?qm_symbol=FBF" onclick="window.open(this.href,'_blank');return false;">FBF</a>.
	              </p>
							<div class="tradingview_wrapper">
                <div class="tradingview-widget-container">
	                <div id="tradingview_c4dab"></div>
	                  <div class="tradingview-widget-copyright">
	                    <a rel="noreferrer" href="https://www.tradingview.com/symbols/TSXV-FBF/" rel="noopener" onclick="window.open(this.href,'_blank');return false;">
	                      <span class="blue-text">FBF chart</span>
	                    </a> by TradingView
	                  </div>
	                </div>
                </div>
						  </div>
            `,
          },
        ],
      },
      {
        id: "financials",
        menuItem: {
          en: {
            title: "Financials",
            menu: "Financials",
            url: urls.investor.financials,
            metaTitle: "Fab-Form Financials - Quarterly and Annual Reports",
            metaDescription: "Access Fab-Form's financial statements and MD&A reports for each quarter and year, including the latest earnings reports and investor materials.",
          },
        },
        images: [],
        articles: [
          {
            title: "",
            body: `
							<div class="financials-wrapper">
								<p>In 2023, the Company changed the year end from 31 December to the 30 June. The reason for this change was the difficulty in finding auditors for the calendar year end. This required an external audit of the financial statements on the 30th June 2023.</p>
								<p>As a result, the 3rd quarter of 2023 became the 1st quarter of the new financial year; the 4th quarter of 2023 became the 2nd quarter of the new financial year; and June 30 2024 was the date for the new financial year end statements, audited by Baker Tilly.</p>
								<table class="table financials-table">
									<thead>
										<tr>
											<th scope="col">Year</td>
											<th scope="col">Quarter</td>
											<th scope="col">Reports</td>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>2024/2025</td>
											<td>3rd</td>
											<td>
												<a href="/financials/2024-2025-3rd-qtr-financials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2024-2025-3rd-qtr-MD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a>
											</td>
										</tr> 
										<tr>
											<td>2024/2025</td>
											<td>2nd</td>
											<td>
												<a href="/financials/2024-2025-2nd-qtr-financials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2024-2025-2nd-qtr-MD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a>
											</td>
										</tr> 
										<tr>
											<td>2024/2025</td>
											<td>1st</td>
											<td>
												<a href="/financials/2024-2025-1st-qtr-financials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2024-2025-1st-qtr-MD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a>
											</td>
										</tr> 
										<tr>
											<td>2023/2024</td>
											<td>4th</td>
											<td>
												<a href="/financials/2023-2024-4th-qtr-financials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2023-2024-4th-qtr-MD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a>	
											</td>
										</tr> 
										<tr>
											<td>2023/2024</td>
											<td>3rd</td>
											<td>
												<a href="/financials/2023-2024-3rd-qtr-financials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2023-2024-3rd-qtr-MD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a>	
											</td>
										</tr> 
										<tr>
											<td>2023/2024</td>
											<td>2nd</td>
											<td>
												<a href="/financials/2023-2024-2nd-qtr-financials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2023-2024-2nd-qtr-MD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a>	
											</td>
										</tr>  
										<tr>
											<td>2023/2024</td>
											<td>1st</td>
											<td>
												<a href="/financials/2023-2024-1st-qtr-financials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2023-2024-1st-qtr-MD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a>
											</td>
										</tr>
										<tr>
											<td>2023</td>
											<td>2nd</td>
											<td>
												<a href="/financials/2023-2ndQtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2023-2ndQtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a>
											</td>
										</tr>  
										<tr>
											<td>2023</td>
											<td>1st</td>
											<td>
												<a href="/financials/2023-1stQtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2023-1stQtrMD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a>
											</td>
										</tr>                 
										<tr>
											<td>2022</td>
											<td>3rd</td>
											<td>
												<a href="/financials/2022-3QtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2022-3QtrMD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a></td>
										</tr>
										<tr>
											<td>2022</td>
											<td>2nd</td>
											<td>
												<a href="/financials/2022-2QtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2022-2QtrMD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a></td>
										</tr>
										<tr>
											<td>2022</td>
											<td>1st</td>
											<td>
												<a href="/financials/2022-1QtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2022-1QtrMD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a></td>
										</tr>
										<tr>
											<td>2021</td>
											<td>4th</td>
											<td>
												<a href="/financials/2021-4QtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2021-4QtrMD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a></td>
										</tr>
										<tr>
											<td>2021</td>
											<td>3rd</td>
											<td>
												<a href="/financials/2021-3QtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2021-3QtrMD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a></td>
										</tr>
										<tr>
											<td>2021</td>
											<td>2nd</td>
											<td>
												<a href="/financials/2021-2QtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2021-2QtrMD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a></td>
										</tr>
										<tr>
											<td>2021</td>
											<td>1st</td>
											<td>
												<a href="/financials/2021-1QtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2021-1QtrMD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a></td>
										</tr>
										<tr>
											<td>2020</td>
											<td>4th</td>
											<td>
												<a href="/financials/2020-4QtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2020-4QtrMD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a></td>
										</tr>
										<tr>
											<td>2020</td>
											<td>3rd</td>
											<td>
												<a href="/financials/2020-3QtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2020-3QtrMD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a></td>
										</tr>
										<tr>
											<td>2020</td>
											<td>2nd</td>
											<td>
												<a href="/financials/2020-2QtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2020-2QtrMD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a></td>
										</tr>
										<tr>
											<td>2020</td>
											<td>1st</td>
											<td>
												<a href="/financials/2020-1QtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2020-1QtrMD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a></td>
										</tr>
										<tr>
											<td>2019</td>
											<td>4th</td>
											<td>
												<a href="/financials/2019-4QtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2019-4QtrMD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a></td>
										</tr>
										<tr>
											<td>2019</td>
											<td>3rd</td>
											<td>
												<a href="/financials/2019-3rdQtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2019-3rdQtrMD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a></td>
										</tr>
										<tr>
											<td>2019</td>
											<td>2nd</td>
											<td>
												<a href="/financials/2019-2ndQtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2019-2ndQtrMD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a></td>
										</tr>
										<tr>
											<td>2019</td>
											<td>1st</td>
											<td>
												<a href="/financials/2019-1stQtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2019-1stQtrMD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a></td>
										</tr>
										<tr>
											<td>2018</td>
											<td>4th</td>
											<td>
												<a href="/financials/2018-4thQtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2018-4thQtrMD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a></td>
										</tr>
										<tr>
											<td>2018</td>
											<td>3rd</td>
											<td>
												<a href="/financials/2018-3rdQtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2018-3rdQtrMD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a></td>
										</tr>
										<tr>
											<td>2018</td>
											<td>2nd</td>
											<td>
												<a href="/financials/2018-2ndQtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2018-2ndQtrMD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a></td>
										</tr>
										<tr>
											<td>2018</td>
											<td>1st</td>
											<td>
												<a href="/financials/2018-1stQtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2018-1stQtrMD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a></td>
										</tr>
										<tr>
											<td>2017</td>
											<td>4th</td>
											<td>
												<a href="/financials/2017-4thQtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2017-4thQtrMD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a></td>
										</tr>
										<tr>
											<td>2017</td>
											<td>3rd</td>
											<td>
												<a href="/financials/2017-3rdQtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2017-3rdQtrMD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a></td>
										</tr>
										<tr>
											<td>2017</td>
											<td>2nd</td>
											<td>
												<a href="/financials/2017-2ndQtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2017-2ndQtrMD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a></td>
										</tr>
										<tr>
											<td>2017</td>
											<td>1st</td>
											<td>
												<a href="/financials/2017-1stQtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2017-1stQtrMD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a></td>
										</tr>
										<tr>
											<td>2016</td>
											<td>4th</td>
											<td>
												<a href="/financials/2016-4thQtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2016-4thQtrMD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a></td>
										</tr>
										<tr>
											<td>2016</td>
											<td>3rd</td>
											<td>
												<a href="/financials/2016-3rdQtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2016-3rdQtrMD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a></td>
										</tr>
										<tr>
											<td>2016</td>
											<td>2nd</td>
											<td>
												<a href="/financials/2016-2ndQtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2016-2ndQtrMD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a></td>
										</tr>
										<tr>
											<td>2016</td>
											<td>1st</td>
											<td>
												<a href="/financials/2016-1stQtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2016-1stQtrMD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a></td>
										</tr>
										<tr>
											<td>2015</td>
											<td>4th</td>
											<td>
												<a href="/financials/2015-4thQtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2015-4thQtrMD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a></td>
										</tr>
										<tr>
											<td>2015</td>
											<td>3rd</td>
											<td>
												<a href="/financials/2015-3rdQtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2015-3rdQtrMD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a></td>
										</tr>
										<tr>
											<td>2015</td>
											<td>2nd</td>
											<td>
												<a href="/financials/2015-2ndQtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2015-2ndQtrMD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a></td>
										</tr>
										<tr>
											<td>2015</td>
											<td>1st</td>
											<td>
												<a href="/financials/2015-1stQtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2015-1stQtrMD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a></td>
										</tr>
										<tr>
											<td>2014</td>
											<td>4th</td>
											<td>
												<a href="/financials/2014-4thQtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2014-4thQtrMD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a></td>
										</tr>
										<tr>
											<td>2014</td>
											<td>3rd</td>
											<td>
												<a href="/financials/2014-3rdQtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2014-3rdQtrMD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a></td>
										</tr>
										<tr>
											<td>2014</td>
											<td>2nd</td>
											<td>
												<a href="/financials/2014-2ndQtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2014-2ndQtrMD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a></td>
										</tr>
										<tr>
											<td>2014</td>
											<td>1st</td>
											<td>
												<a href="/financials/2014-1stQtrFinancials.pdf" onclick="window.open(this.href,'_blank');return false;">Financial</a> /
												<a href="/financials/2014-1stQtrMD&A.pdf" onclick="window.open(this.href,'_blank');return false;">MD&A</a></td>
										</tr>
									</tbody>
								</table>
								<p>For earlier financial reports, go to 
								<a rel="noreferrer" href="https://www.sedar.com/DisplayProfile.do?lang=EN&issuerType=03&issuerNo=00008449" onclick="window.open(this.href,'_blank');return false;">SEDAR</a>.</p>
							</div>`,
          },
        ],
      },
      {
        id: "governance",
        menuItem: {
          en: {
            title: "Governance",
            menu: "Governance",
            url: urls.investor.governance,
            metaTitle: "Fab-Form Corporate Governance - Board, Management, and Guidelines",
            metaDescription: "Explore Fab-Form's corporate governance practices, including the roles of our Board of Directors, executive management, and governance guidelines.",
          },
        },
        images: [],
        articles: [
          {
            title: "Corporate Governance",
            body: `
                            <div>
								<p>The Board of Directors of Fab-Form Industries Ltd. (the "Company") is responsible for setting 
									high standards for the Company's employees, officers, and directors. It is the Board’s duty to act 
									as a prudent fiduciary for shareholders and to oversee the management of the Company’s operations. 
									To fulfill these responsibilities, the Board adheres to the procedures and principles outlined in the 
									governance documents listed below. These guidelines may be amended from time to time as the Board 
									considers appropriate, or as required by applicable laws and regulations.</p>

								<ul>
									<li><a href="/en/${urls.investor.corporateGovernanceGuidelines}">Corporate Governance Guidelines</a></li>
									<li><a href="/en/${urls.investor.auditCommitteeCharter}">Audit Committee Charter</a></li>
									<li><a href="/en/${urls.investor.codeBusinessConduct}">Code of Business Conduct and Ethics</a></li>
									<li><a href="/en/${urls.investor.compensationCommitteeCharter}">Compensation Committee Charter</a></li>
								</ul>
							</div>
						`,
            image: "",
          },
          {
            title: "Management",
            body: `
              <ul>
								<li>Joey Fearn - CEO</li>
								<li>Rick Fearn - Founder</li>
								<li>Vishwanath Kumar - Chief Financial Officer</li>
								<li>Stephen Gabbott - 3D Modeling and Estimating</li>
								<li>Jack Leung - Manager, New Product Design</li>
								<li>Max Kameniev - Manager, IT</li>
								<li>Kris Schollen - Manager, Vancouver ICF</li>
								<li>Johanna Vaca - Manager, International Sales</li>
								<li>Chauki Yousef - Warehouse Manager</li>
							</ul>
						`,
            image: "",
          },
          {
            title: "Board of Directors",
            body: `
              <ul>
		            <li>Rick Fearn - Director, not Independent</li>
		            <li>Joey Fearn - Director, not Independent</li>
		            <li>Don Russell - Director, Independent</li>
		            <li>Nigel Protter - Director, Independent</li>
	            </ul>
            `,
            image: "",
          },
        ],
      },
      {
        id: "agm",
        menuItem: {
          en: {
            title: "Fab-Form AGM",
            menu: "AGM",
            url: urls.investor.agm,
            metaTitle: "Fab-Form Annual General Meeting (AGM) - December 2024",
            metaDescription: "Join Fab-Form's Annual General Meeting in December 2024. Learn about key developments, voting instructions, and financial updates.",
          },
        },
        images: ["/images/remote-alaska-solutions.webp"],
        body: `
                    <div class="page_article">
                        <p>Even in remote Alaska, Fastfoot can be found. This project was supplied by our dealer 
                            <a rel="noreferrer" href="https://www.remoteak.com" onclick="window.open(this.href,'_blank');return false;">Remote Alaska Solutions</a>, 
                                located in Palmer, Alaska.
                        </p>
                    </div>`,
        articles: [
          {
            title:
              "Fab-Form Annual General Meeting, Friday, 20 December 2024, 3:00 PM PST",
            body: `<div>
                            <div class="page_articleSelection--light">
                                <p>Dear Shareholders</p>
								<p>On behalf of Fab-Form's Board of Directors and employees, we are pleased to invite you to attend the Annual General Meeting of Shareholders on Friday, 20 December 2024, to be held at the Fab-Form head office, Unit 19, 1610 Derwent Way, Delta, British Columbia at 3:00 pm Pacific time. Should you wish to attend by Zoom, please email vish@fab-form.com and we will send you the correct link and login credentials. The Notice of Annual General Meeting and Management Proxy Circular contains important information about the meeting, voting, nominated directors, our governance practices and executive and directors' compensation. It also describes the Boards' roles and responsibilities and the key activities the Board undertook during the period ended 30 June 2024.</p>
								<p>Your vote is important. We encourage you to participate in this process by voting your shares and, if possible, by attending the Annual General Meeting. Whether you choose to vote by proxy or in person
									<strong>we appreciate your participation</strong>.</p>
								<p>Please contact admin@fab-form.com for online voting instructions.</p>
								<p>Sincerely</p>
								<p>Vishwanath Kumar, Corporate Secretary</p>
        						<p><a href="otherFiles/new-proxy-form.pdf" target="_blank">Proxy Form</a></p>
        						<p><a href="otherFiles/new-management-information-circular.pdf" target="_blank">Management Information Circular</a></p>
        						<p><a href="financials/2023-2024-4th-qtr-financials.pdf" target="_blank">Annual financial statements for the year ended 30 June 2024</a></p>
                            </div>
						</div>`,
            image: "",
          },
        ],
      },
      {
        id: "press-releases",
        menuItem: {
          en: {
            title: "Press Releases",
            menu: "Press Releases",
            url: urls.investor.pressReleases,
            metaTitle: "Fab-Form Press Releases - Company News and Announcements",
            metaDescription: "Stay updated with the latest press releases from Fab-Form, including financial statements, product announcements, and other corporate news.",
          },
        },
        images: [],
        body: "",
        articles: [
          {
            title: "",
            body: `
							<div class="press-release-wrapper">
								<table id="pressRelease">
									<tr>
										<td>Year</td>
										<td>Date</td>
										<td>Description</td>
									</tr>
									<tr>
										<td>2025</td>
										<td class="wp-nowrap">31 Mar</td>
										<td class="text-start"><a href="/${lang}/${urls.investor.financials}" target="_blank">2024/2025 Third Quarter Financial Statements and MD&A</a></td>
									</tr>
									<tr>
										<td>2025</td>
										<td class="wp-nowrap">31 Dec</td>
										<td class="text-start"><a href="/${lang}/${urls.investor.financials}" target="_blank">2024/2025 Second Quarter Financial Statements and MD&A</a></td>
									</tr>
									<tr>
										<td>2024</td>
										<td class="wp-nowrap">20 Dec</td>
										<td class="text-start"><a href="/docs/agm-minutes-2024_new.pdf" target="_blank">2024 December AGM Minutes</a></td>
									</tr>
									<tr>
										<td>2024</td>
										<td class="wp-nowrap">28 Nov</td>
										<td class="text-start"><a href="/${lang}/${urls.investor.financials}">2024/2025 First Quater Financial Statements and MD&A</a></td>
									</tr>
									<tr>
										<td>2024</td>
										<td class="wp-nowrap">28 Nov</td>
										<td class="text-start"><a href="/docs/new-proxy-form.pdf">Proxy Form</a></td>
									</tr>
									<tr>
										<td>2024</td>
										<td class="wp-nowrap">28 Nov</td>
										<td class="text-start"><a href="/docs/new-management-information-circular.pdf">Management information circular to shareholders</a></td>
									</tr>
									<tr>
										<td>2024</td>
										<td class="wp-nowrap">22 Nov</td>
										<td class="text-start"><a href="/docs/Fab-Form-Announces-New-Patent-for-Fast-Tube_2024.pdf">Announcement of patent for a method of installing and supporting a fabric column form</a></td>
									</tr>
									<tr>
										<td>2024</td>
										<td class="wp-nowrap">21 Nov</td>
										<td class="text-start"><a href="/docs/2024-nov-21-amended-notice-of-meeting.pdf">Amended Notice of Annual General Meeting</a></td>
									</tr>
									<tr>
										<td>2024</td>
										<td class="wp-nowrap">25 Oct</td>
										<td class="text-start"><a href="/${lang}/${urls.investor.financials}">2023/2024 Annual Financial Statements and MD&amp;A</a></td>
									</tr>
									<tr>
										<td>2024</td>
										<td class="wp-nowrap">23 Oct</td>
										<td class="text-start"><a href="world-of-concrete">Fab-Form Industries at World of Concrete 2025</a></td>
									</tr>
									<tr>
										<td>2024</td>
										<td class="wp-nowrap">23 Oct</td>
										<td class="text-start"><a href="/docs/footing-bracket-invention-completion-of-protypes.pdf" target="_blank">Announcement of patent, trademark applications and completeon of prototypes of <strong>LEVEL-R™</strong> and <strong>MONOPOUR HD™</strong></a></td>
									</tr>
									<tr>
										<td>2024</td>
										<td class="wp-nowrap">22 Jul</td>
										<td class="text-start"><a href="/${lang}/${urls.investor.newProducts}" target="_blank">Announcement of patent application for new product, <strong>SPACE-R</strong></a></td>
									</tr>
									<tr>
										<td>2024</td>
										<td class="wp-nowrap">31 May</td>
										<td class="text-start"><a href="/${lang}/${urls.investor.financials}">2023/2024 Third Quarter Financial Statements and MD&amp;A</a></td>
									</tr>
									<tr>
										<td>2024</td>
										<td class="wp-nowrap">28 Feb</td>
										<td class="text-start"><a href="/${lang}/${urls.investor.financials}">2023/2024 Second Quarter Financial Statements and MD&amp;A</a></td>
									</tr>
									<tr>
										<td>2024</td>
										<td class="wp-nowrap">29 Jan</td>
										<td class="text-start"><a href="/docs/Notice-of-Change-of-Auditor.pdf">Notice of Change of Auditor</a></td>
									</tr>
									<tr>
										<td>2023</td>
										<td class="wp-nowrap">22 Dec</td>
										<td class="text-start"><a href="/docs/AGM-Meeting-Minutes-22-Dec-2023.pdf" target="_blank">2023 December AGM Minutes</a></td>
									</tr>
									<tr>
										<td>2023</td>
										<td class="wp-nowrap">1 Dec</td>
										<td class="text-start"><a href="/docs/Appointment-of-CEO-&-CFO.pdf">Appointment of CEO & CFO</a></td>
									</tr>
									<tr>
										<td>2023</td>
										<td class="wp-nowrap">29 Nov</td>
										<td class="text-start"><a href="/${lang}/${urls.investor.financials}">2023/2024 First Quarter Financial Statements and MD&amp;A</a></td>
									</tr>
									<tr>
										<td>2023</td>
										<td class="wp-nowrap">8 Nov</td>
										<td class="text-start"><a href="/docs/Notice-of-AGM-Information-Circular-and-Proxy-2023_Dec.pdf">Notice of AGM, Information Circular and Proxy</a></td>
									</tr>
									<tr>
										<td>2023</td>
										<td class="wp-nowrap">27 Oct</td>
										<td class="text-start"><a href="/${lang}/${urls.investor.financials}">2023 Second Quarter Financial Statements and MD&amp;A</a></td>
									</tr>
									<tr>
										<td>2023</td>
										<td class="wp-nowrap">30 Aug</td>
										<td class="text-start"><a href="/docs/Notice-of-Year-Change-and-Transitional-Year-Filing.pdf">Notice of Year Change and Transitional Year Filing</a></td>
									</tr>
									<tr>
										<td>2023</td>
										<td class="wp-nowrap">16 Aug</td>
										<td class="text-start"><a href="/docs/step-5-development-in-bc.pdf">News Release-Step 5 Development in BC</a></td>
									</tr>
									<tr>
										<td>2023</td>
										<td class="wp-nowrap">23 Jun</td>
										<td class="text-start"><a href="/docs/meeting_minutes_agm_23_june_2023.pdf" target="_blank">2023 AGM Minutes</a></td>
									</tr>
									<tr>
										<td>2023</td>
										<td class="wp-nowrap">29 May</td>
										<td class="text-start"><a href="/${lang}/${urls.investor.financials}">2023 First Quarter Financial Statements and MD&amp;A</a></td>
									</tr>
									<tr>
										<td>2023</td>
										<td class="wp-nowrap">9 May</td>
										<td class="text-start"><a href="/docs/notice_of_AGM_Information_Circular_and_Proxy_2023.pdf" target="_blank">Notice of AGM, Information Circular and Proxy</a></td>
									</tr>
									<tr>
										<td>2023</td>
										<td class="wp-nowrap">5 May</td>
										<td class="text-start"><a href="/docs/News_Release-Year_end_change.pdf">News Release-Year end change</a></td>
									</tr>
									<tr>
										<td>2023</td>
										<td class="wp-nowrap">21 Feb</td>
										<td class="text-start"><a href="/tsx-venture-50">Fab-Form Ranks Amoung Top 50 on 2023 TSX Venture 50</a></td>
									</tr>
									<tr>
										<td>2022</td>
										<td class="wp-nowrap">22 Nov</td>
										<td class="text-start"><a href="/${lang}/${urls.investor.financials}">2022 Third Quarter Financial Statements and MD&A</a></td>
									</tr>
									<tr>
										<td>2022</td>
										<td class="wp-nowrap">23 Aug</td>
										<td class="text-start"><a href="/${lang}/${urls.investor.financials}">2022 Second Quarter Financial Statements and MD&A</a></td>
									</tr>
									<tr>
										<td>2022</td>
										<td class="wp-nowrap">24 Jun</td>
										<td class="text-start"><a href="/docs/agm-minutes-24-june-2022.pdf" onclick="window.open(this.href,'_blank');return false;">2022 AGM Minutes</a></td>
									</tr>
									<tr>
										<td>2022</td>
										<td class="wp-nowrap">26 May</td>
										<td class="text-start"><a href="/${lang}/${urls.investor.financials}">2022 First Quarter Financial Statements and MD&A</a></td>
									</tr>
									<tr>
										<td>2022</td>
										<td class="wp-nowrap">29 Apr</td>
										<td class="text-start"><a href="/${lang}/${urls.investor.financials}">2021 Fourth Quarter Financial Statements and MD&A</a></td>
									</tr>
									<tr>
										<td>2022</td>
										<td class="wp-nowrap">25 Apr</td>
										<td class="text-start"><a href="/docs/notice-of-meeting-information-circular-proxy-2022.pdf" onclick="window.open(this.href,'_blank');return false;">Notice of AGM, Information Circular and Proxy</a></td>
									</tr>
									<tr>
										<td>2021</td>
										<td class="wp-nowrap">24 Nov</td>
										<td class="text-start"><a href="/docs/notice-of-hagihara-fabric-development-agreement.pdf" onclick="window.open(this.href,'_blank');return false;">Fab-Form Announces Fabric Development Agreement with Hagihara Industries Inc.</a></td>
									</tr>
									<tr>
										<td>2021</td>
										<td class="wp-nowrap">24 Nov</td>
										<td class="text-start"><a href="/${lang}/${urls.investor.financials}">2021 Third Quarter Financial Statements and MD&A</a></td>
									</tr>
									<tr>
										<td>2021</td>
										<td class="wp-nowrap">28 Oct</td>
										<td class="text-start"><a href="/docs/completion-of-debt-settlement-28-oct-2021.pdf" onclick="window.open(this.href,'_blank');return false;">Fab-Form Announces Completion of Debt Settlement</a></td>
									</tr>
									<tr>
										<td>2021</td>
										<td class="wp-nowrap">18 Oct</td>
										<td class="text-start"><a href="/docs/notice-of-debt-settlement-18-oct-2021.pdf" onclick="window.open(this.href,'_blank');return false;">Notice of Debt Settlement</a></td>
									</tr>
									<tr>
										<td>2021</td>
										<td class="wp-nowrap">20 Aug</td>
										<td class="text-start"><a href="/${lang}/${urls.investor.financials}">2021 Second Quarter Financial Statements and MD&A</a></td>
									</tr>
									<tr>
										<td>2021</td>
										<td class="wp-nowrap">28 Jun</td>
										<td class="text-start"><a href="/docs/agm-minutes-25-june-2021.pdf" onclick="window.open(this.href,'_blank');return false;">2021 AGM Minutes</a></td>
									</tr>
									<tr>
										<td>2021</td>
										<td class="wp-nowrap">20 May</td>
										<td class="text-start"><a href="/${lang}/${urls.investor.financials}">2021 First Quarter Financial Statements and MD&A</a></td>
									</tr>
									<tr>
										<td>2021</td>
										<td class="wp-nowrap">26 Apr</td>
										<td class="text-start"><a href="/${lang}/${urls.investor.financials}">2020 Fourth Quarter Financial Statements and MD&A</a></td>
									</tr>
									<tr>
										<td>2021</td>
										<td class="wp-nowrap">9 Apr</td>
										<td class="text-start"><a href="/docs/notice-of-meeting-information-circular-proxy-2021.pdf" onclick="window.open(this.href,'_blank');return false;">Notice of AGM, Information Circular and Proxy</a></td>
									</tr>
									<tr>
										<td>2020</td>
										<td class="wp-nowrap">10 Dec</td>
										<td class="text-start"><a href="/docs/nigel-protter-appointment.pdf" onclick="window.open(this.href,'_blank');return false;">Fab-Form announces the appointment of new director, Nigel Protter</a></td>
									</tr>
									<tr>
										<td>2020</td>
										<td class="wp-nowrap">10 Dec</td>
										<td class="text-start"><a href="/docs/bruce-clark-retirement.pdf" onclick="window.open(this.href,'_blank');return false;">Fab-Form announces the retirement of director, Bruce Clark</a></td>
									</tr>
									<tr>
										<td>2020</td>
										<td class="wp-nowrap">20 Oct</td>
										<td class="text-start"><a href="/${lang}/${urls.investor.financials}">Fab-Form releases 2020 Third Quarter Financial Statements and MD&A</a></td>
									</tr>
									<tr>
										<td>2020</td>
										<td class="wp-nowrap">27 July</td>
										<td class="text-start"><a href="/${lang}/${urls.investor.financials}">Fab-Form releases 2020 Second Quarter Financial Statements and MD&A</a></td>
									</tr>
									<tr>
										<td>2020</td>
										<td class="wp-nowrap">26 June</td>
										<td class="text-start"><a href="/docs/looking-forward-2020-2021.pdf" onclick="window.open(this.href,'_blank');return false;">Looking Forward 2020-2021</a></td>
									</tr>
									<tr>
										<td>2020</td>
										<td class="wp-nowrap">26 June</td>
										<td class="text-start"><a href="/docs/agm-minutes-26-june-2020.pdf" onclick="window.open(this.href,'_blank');return false;">Minutes of 2020 AGM</a></td>
									</tr>
									<tr>
										<td>2020</td>
										<td class="wp-nowrap">20 May</td>
										<td class="text-start"><a href="/${lang}/${urls.investor.financials}">Fab-Form releases 2020 First Quarter Financial Statements and MD&A</a></td>
									</tr>
									<tr>
										<td>2020</td>
										<td class="wp-nowrap">30 Apr</td>
										<td class="text-start"><a href="/${lang}/${urls.investor.financials}">Fab-Form releases 2019 Year end Financial Statements and MD&A</a></td>
									</tr>
									<tr>
										<td>2020</td>
										<td class="wp-nowrap">27 Feb</td>
										<td class="text-start"><a href="/docs/notice-of-meeting-information-circular-proxy-2020.pdf" onclick="window.open(this.href,'_blank');return false;">Notice of AGM, Information Circular and Proxy</a></td>
									</tr>
									<tr>
										<td>2019</td>
										<td class="wp-nowrap">31 Oct</td>
										<td class="text-start"><a href="/${lang}/${urls.investor.financials}">Fab-Form releases 2019 Third Quarter Financial Statements and MD&A</a></td>
									</tr>
									<tr>
										<td>2019</td>
										<td class="wp-nowrap">22 Aug</td>
										<td class="text-start"><a href="/${lang}/${urls.investor.financials}">Fab-Form releases 2019 Second Quarter Financial Statements and MD&A</a></td>
									</tr>
									<tr>
										<td>2019</td>
										<td class="wp-nowrap">30 July</td>
										<td class="text-start"><a href="/docs/agm-minutes-30-july-2019.pdf" onclick="window.open(this.href,'_blank');return false;">Minutes of 2019 AGM</a></td>
									</tr>
									<tr>
										<td>2019</td>
										<td class="wp-nowrap">31 May</td>
										<td class="text-start"><a href="/docs/notice-of-meeting-information-circular-proxy-2019.pdf" onclick="window.open(this.href,'_blank');return false;">Notice of AGM and Information Circular</a></td>
									</tr>
									<tr>
										<td>2019</td>
										<td class="wp-nowrap">30 May</td>
										<td class="text-start"><a href="/${lang}/${urls.investor.financials}">Fab-Form releases 2019 First Quarter Financial Statements and MD&A</a></td>
									</tr>
									<tr>
										<td>2019</td>
										<td class="wp-nowrap">30 Apr</td>
										<td class="text-start"><a href="/${lang}/${urls.investor.financials}">Fab-Form releases 2018 Fourth Quarter Financial Statements and MD&A</a></td>
									</tr>
									<tr>
										<td>2018</td>
										<td class="wp-nowrap">27 Nov</td>
										<td class="text-start"><a href="/${lang}/${urls.investor.financials}">Fab-Form releases 2018 Third Quarter Financial Statements and MD&A</a></td>
									</tr>
									<tr>
										<td>2018</td>
										<td class="wp-nowrap">30 Aug</td>
										<td class="text-start"><a href="/${lang}/${urls.investor.financials}">Fab-Form releases 2018 Second Quarter Financial Statements and MD&A</a></td>
									</tr>
									<tr>
										<td>2018</td>
										<td class="wp-nowrap">6 July</td>
										<td class="text-start"><a href="/docs/agm-minutes-6-july-2018.pdf" onclick="window.open(this.href,'_blank');return false;">Minutes of&nbsp;2018 AGM</a></td>
									</tr>
									<tr>
										<td>2018</td>
										<td class="wp-nowrap">30 May</td>
										<td class="text-start"><a href="/${lang}/${urls.investor.financials}" onclick="window.open(this.href,'_blank');return false;">Fab-Form releases 2018 First Quarter Financial Statements and MD&A</a></td>
									</tr>
									<tr>
										<td>2018</td>
										<td class="wp-nowrap">7 May</td>
										<td class="text-start"><a href="/docs/notice-of-meeting-information-circular-proxy-2018.pdf" onclick="window.open(this.href,'_blank');return false;">Notice of 2018 AGM, Information Circular, Proxy</a></td>
									</tr>
									<tr>
										<td>2018</td>
										<td class="wp-nowrap">30 Apr</td>
										<td class="text-start"><a href="/${lang}/${urls.investor.financials}">Fab-Form releases 2017 year end Financial Statements and MD&A</a></td>
									</tr>
									<tr>
										<td>2018</td>
										<td class="wp-nowrap">12 Jan</td>
										<td class="text-start"><a href="/docs/pletion.pdf">Fab-Form announces completion of private placement</a></td>
									</tr>
									<tr>
										<td>2017</td>
										<td class="wp-nowrap">20 Nov</td>
										<td class="text-start"><a href="/${lang}/${urls.investor.financials}">Fab-Form releases 2017 Third Quarter Financial Statements and MD&A</a></td>
									</tr>
									<tr>
										<td>2017</td>
										<td class="wp-nowrap">31 Oct</td>
										<td class="text-start"><a href="/${lang}/${urls.investor.privatePlacement}">Fab-Form announces $500,000 Private Placement</a></td>
									</tr>
									<tr>
										<td>2017</td>
										<td class="wp-nowrap">30 Sep</td>
										<td class="text-start"><a href="/3-new-products">Fab-Form announces three new products for the fall of 2017</a></td>
									</tr>
									<tr>
										<td>2017</td>
										<td class="wp-nowrap">24 Aug</td>
										<td class="text-start"><a href="/${lang}/${urls.investor.financials}">Fab-Form releases 2017 Second Quarter Financial Statements and MD&A</a></td>
									</tr>
									<tr>
										<td>2017</td>
										<td class="wp-nowrap">16 June</td>
										<td class="text-start"><a href="/docs/agm-minutes-16-june-2017.pdf" onclick="window.open(this.href,'_blank');return false;">Minutes of 2017 AGM</a></td>
									</tr>
									<tr>
										<td>2017</td>
										<td class="wp-nowrap">30 May</td>
										<td class="text-start"><a href="/${lang}/${urls.investor.financials}">Fab-Form releases 2017 First Quarter Financial Statements and MD&A</a></td>
									</tr>
									<tr>
										<td>2017</td>
										<td class="wp-nowrap">8 May</td>
										<td class="text-start"><a href="/docs/notice-of-meeting-information-circular-proxy-2017.pdf" onclick="window.open(this.href,'_blank');return false;">Notice of 2017 AGM, Information Circular, Proxy</a></td>
									</tr>
									<tr>
										<td>2017</td>
										<td class="wp-nowrap">30 Apr</td>
										<td class="text-start"><a href="/${lang}/${urls.investor.financials}">Fab-Form releases 2016 Year End Financial Statements and MD&A</a></td>
									</tr>
									<tr>
										<td>2016</td>
										<td class="wp-nowrap">25 Nov</td>
										<td class="text-start"><a href="/${lang}/${urls.investor.financials}">Fab-Form releases 2016 3rd Quarter Financial Statements and MD&A</a></td>
									</tr>
								</table>
							</div>
						`,
            image: "",
          },
        ],
      },
      {
        id: "new-patents",
        menuItem: {
          en: {
            title: "New Patents",
            menu: "New Patents",
            url: "investor/new-patents",
            metaTitle: "Fab-Form New Patents - Innovative Construction Solutions",
            metaDescription: "Discover Fab-Form's latest patented technologies, including the Fast-Tube® form system, Space-R™, and new innovations in construction.",
          },
        },
        articles: [
          {
            title:
              "Method of installing and supporting a fabric form, and a bracket therefor",
            body: `
							<div>
								<p>The Fast-Tube® is a fabric form used for casting concrete columns. To ensure precise alignment, 
									Fab-Form has developed a specialized connector called the “KLiP,” which clips onto the base of 
									the tube and aligns the fabric base to an adjacent 2×4.</p>

								<p>The KLiP connector features a primary elongate member that attaches to the fabric form, and a 
									secondary elongate member that extends outward to connect to a base or formwork, enhancing 
									stability. It supports multiple configurations, including planar and L-shaped forms, for 
									versatile use. Some variations enable snap-fit or clamp-style attachment to the fabric, allowing 
									for flexible and efficient installation. The formwork system incorporates several types of 
									connectors to improve structural integrity, and installation methods are designed to ensure 
									secure alignment and attachment to foundations or temporary supports.</p>
							</div>
						`,
            image: "/images/tube-tail-original-size.webp",
          },
          {
            title: "Form support and length-adjustable assembly",
            body: `
							<div>
								<p>Achieving perfectly level footings is critical for structural integrity in buildings around the world. 
									This invention introduces an improved form support system featuring a length-adjustable assembly 
									engineered for versatility and precision. Key components and features include:</p>

								<ul>
									<li><strong>Length-Adjustable Assembly:</strong> Consists of a pair of telescoping members, a removable 
										end member, and a rotatable male threaded member. This design enables precise length adjustment 
										while preventing unwanted axial movement.</li>

									<li><strong>Form Support Structure:</strong> Incorporates the length-adjustable assembly to reposition 
										the upper and lower telescoping members. It supports multiple configurations such as mounts, 
										L-shaped brackets, and baseplates with multi-aperture options.</li>

									<li><strong>Versatile Configurations:</strong> Designed to accommodate a wide range of applications, 
										the system supports all possible combinations of the described features—whether used independently 
										or in combination.</li>
								</ul>
							</div>
						`,
            image: "/images/length-adjustable-assembly.webp",
          },
          {
            title: "SPACE-R™",
            body: `
							<div>
								<p>Every concrete column requires reinforcement to achieve greater structural strength. The vertical reinforcing bars must be held in the correct position, and adequate concrete cover must be placed over the reinforcing.</p>

								<p>This invention secures the vertical reinforcing bars in their proper position while simultaneously providing sufficient concrete cover. Additionally, it enhances both the shear and tensile strength of the concrete column.</p>

								<p>The formwork assembly includes a plurality of receptacles that are circumferentially spaced, coupled to, and extend radially inward from the hoop reinforcement. These receptacles ensure proper positioning and spacing of the vertical reinforcing bars.</p>

								<p>It also includes a plurality of spacers, similarly circumferentially spaced, which are coupled to and extend radially outward from the hoop reinforcement to maintain the correct alignment within the column form.</p>
							</div>

						`,
            image: "/images/space-r-drawings.webp",
          },
        ],
      },
    ],
  },
	{
		id: "contact-us",
		menuItem: {
		en: {
			title: "Contact Us",
			menu: "Contact Us",
			url: "",
			metaTitle: "Contact Fab-Form Industries - Get in Touch",
			metaDescription: "Contact Fab-Form Industries for inquiries, product information, or customer support. Reach out to our team for assistance.",
		},
		},
		images: [],
		articles: [],
	},
	{
		id: "career",
		menuItem: {
		en: {
			title: "Career",
			menu: "Career",
			url: "career-opportunities",
			metaTitle: "Career Opportunities at Fab-Form Industries - Join Our Team",
			metaDescription: "Explore exciting career opportunities at Fab-Form Industries. Join our innovative team and help us shape the future of construction.",
		},
		},
		images: [],
		articles: [],
	},
];